(function () {
  'use strict';

  var VERSION = '2.1.0-room-preview-studio';
  var PRODUCT_PATH = '/products/custom-infinity-mirror';
  var MAX_CAPTURE_EDGE = 1800;
  var DESKTOP_EMBED_QUERY = '(min-width: 900px)';
  var DEFAULT_ROOM_ID = 'reception';
  var MAX_CUSTOM_PHOTO_BYTES = 20 * 1024 * 1024;
  var MAX_CUSTOM_PHOTO_EDGE = 2400;
  var CUSTOM_SCALE_MIN = 50;
  var CUSTOM_SCALE_MAX = 200;
  var CUSTOM_SCALE_STEP = 5;
  var SIZE_HINT_KEY = 'maytrix:room-preview:size-hint-seen';
  var SIZE_MODE_CATEGORY_ID = 'LB4oi7z56Ta0OZehKxWNh6o0';
  var CUSTOM_SIZE_OPTION_ID = 'hHvqdwVPeJimgKlbmK7ysr_Y';
  var assets = window.__MAYTRIX_ROOM_PREVIEW_ASSETS__ || {};

  if (window.__MAYTRIX_ROOM_PREVIEW__) return;

  var rooms = [
{
    "id": "reception",
    "label": "Reception",
    "width": 1254,
    "height": 1254,
    "mobileWidth": 768,
    "mobileHeight": 1365,
    "pixelsPerInch": 8.8,
    "mobilePixelsPerInch": 7.1,
    "x": 0.5,
    "y": 0.4,
    "mobileX": 0.5,
    "mobileY": 0.39,
    "wall": {
        "xMin": 0.165,
        "xMax": 0.835,
        "yMin": 0.045,
        "yMax": 0.59
    },
    "mobileWall": {
        "xMin": 0.145,
        "xMax": 0.865,
        "yMin": 0.045,
        "yMax": 0.555
    }
,
    "image": assets.reception,
    "mobileImage": assets.receptionMobile,
    "thumb": assets.receptionThumb
  },
{
    "id": "restaurant",
    "label": "Restaurant",
    "width": 1254,
    "height": 1254,
    "mobileWidth": 768,
    "mobileHeight": 1365,
    "pixelsPerInch": 8.0,
    "mobilePixelsPerInch": 7.8,
    "x": 0.5,
    "y": 0.38,
    "mobileX": 0.5,
    "mobileY": 0.39,
    "wall": {
        "xMin": 0.15,
        "xMax": 0.85,
        "yMin": 0.025,
        "yMax": 0.53
    },
    "mobileWall": {
        "xMin": 0.065,
        "xMax": 0.91,
        "yMin": 0.045,
        "yMax": 0.565
    }
,
    "image": assets.restaurant,
    "mobileImage": assets.restaurantMobile,
    "thumb": assets.restaurantThumb
  },
{
    "id": "cafe",
    "label": "Café",
    "width": 1254,
    "height": 1254,
    "mobileWidth": 768,
    "mobileHeight": 1365,
    "pixelsPerInch": 8.5,
    "mobilePixelsPerInch": 6.4,
    "x": 0.585,
    "y": 0.405,
    "mobileX": 0.55,
    "mobileY": 0.39,
    "wall": {
        "xMin": 0.3,
        "xMax": 0.88,
        "yMin": 0.03,
        "yMax": 0.58
    },
    "mobileWall": {
        "xMin": 0.25,
        "xMax": 0.875,
        "yMin": 0.055,
        "yMax": 0.64
    }
,
    "image": assets.cafe,
    "mobileImage": assets.cafeMobile,
    "thumb": assets.cafeThumb
  },
{
    "id": "gym",
    "label": "Gym",
    "width": 1254,
    "height": 1254,
    "mobileWidth": 768,
    "mobileHeight": 1365,
    "pixelsPerInch": 9.6,
    "mobilePixelsPerInch": 7.2,
    "x": 0.5,
    "y": 0.42,
    "mobileX": 0.5,
    "mobileY": 0.39,
    "wall": {
        "xMin": 0.19,
        "xMax": 0.86,
        "yMin": 0.04,
        "yMax": 0.65
    },
    "mobileWall": {
        "xMin": 0.15,
        "xMax": 0.85,
        "yMin": 0.04,
        "yMax": 0.64
    }
,
    "image": assets.gym,
    "mobileImage": assets.gymMobile,
    "thumb": assets.gymThumb
  },
{
    "id": "retail",
    "label": "Retail",
    "width": 1254,
    "height": 1254,
    "mobileWidth": 768,
    "mobileHeight": 1365,
    "pixelsPerInch": 10.5,
    "mobilePixelsPerInch": 7.8,
    "x": 0.52,
    "y": 0.44,
    "mobileX": 0.5,
    "mobileY": 0.39,
    "wall": {
        "xMin": 0.16,
        "xMax": 0.885,
        "yMin": 0.025,
        "yMax": 0.685
    },
    "mobileWall": {
        "xMin": 0.085,
        "xMax": 0.91,
        "yMin": 0.04,
        "yMax": 0.685
    }
,
    "image": assets.retail,
    "mobileImage": assets.retailMobile,
    "thumb": assets.retailThumb
  },
{
    "id": "club",
    "label": "Club",
    "width": 1254,
    "height": 1254,
    "mobileWidth": 768,
    "mobileHeight": 1365,
    "pixelsPerInch": 8.5,
    "mobilePixelsPerInch": 6.2,
    "x": 0.5,
    "y": 0.38,
    "mobileX": 0.5,
    "mobileY": 0.39,
    "wall": {
        "xMin": 0.165,
        "xMax": 0.84,
        "yMin": 0.025,
        "yMax": 0.565
    },
    "mobileWall": {
        "xMin": 0.19,
        "xMax": 0.805,
        "yMin": 0.045,
        "yMax": 0.72
    }
,
    "image": assets.club,
    "mobileImage": assets.clubMobile,
    "thumb": assets.clubThumb
  }
  ];

  function defaultRoom() {
    return rooms.find(function (room) { return room.id === DEFAULT_ROOM_ID; }) || rooms[0];
  }

  var customRoom = {
    id: 'custom',
    label: 'Your Room',
    image: '',
    thumb: '',
    width: 0,
    height: 0,
    x: 0.5,
    y: 0.5,
    xMin: 0,
    xMax: 1,
    yMin: 0,
    yMax: 1,
    isCustom: true
  };

  var controller = {
    cta: null,
    hint: null,
    ctaWrapper: null,
    ctaTimer: 0,
    ctaFadeTimer: 0,
    ctaRevealDueAt: 0,
    ctaTransitioning: false,
    ctaTransitionPending: false,
    ctaRevealed: false,
    builderInteracting: false,
    readinessTimer: 0,
    builderReady: false,
    observer: null,
    modeObserver: null,
    dialog: null,
    stage: null,
    sceneImage: null,
    mirror: null,
    mirrorArt: null,
    mirrorArtOff: null,
    lightButton: null,
    loading: null,
    error: null,
    sizeBadge: null,
    sizeBadgeValue: null,
    sizeHint: null,
    sizeHintTimer: 0,
    sizeSheet: null,
    sizeSheetOpener: null,
    sizeChoices: null,
    availableSizeChoices: [],
    sizeStatus: null,
    sizeApplyButton: null,
    sizeCandidate: null,
    sizeCommittedDimensions: null,
    sizeCommitLock: false,
    sizeCommitToken: 0,
    roomButtons: [],
    activeRoom: defaultRoom(),
    positions: {},
    dimensions: null,
    artworkUrl: '',
    artworkOffUrl: '',
    artworkSets: {
      angled: { on: '', off: '' },
      front: { on: '', off: '' }
    },
    mirrorPowered: true,
    lastFocused: null,
    previousBodyOverflow: '',
    dragging: null,
    pinching: null,
    customPointers: new Map(),
    customScale: 100,
    customPhotoUrl: '',
    customPhotoSheet: null,
    customPhotoSheetOpener: null,
    customPhotoStatus: null,
    customPhotoButton: null,
    customPhotoInput: null,
    customCameraInput: null,
    customLibraryInput: null,
    customControls: null,
    customScaleInput: null,
    customScaleOutput: null,
    tip: null,
    placedThisOpen: false,
    resizeHandler: null,
    keyHandler: null,
    embedded: false,
    embeddedHost: null,
    embeddedBoundsFrame: 0,
    embeddedScrollHandler: null,
    embeddedResizeObserver: null,
    builderUpdateTimer: 0,
    builderSyncToken: 0,
    roomLoadToken: 0,
    openToken: 0
  };

  function isBuilderMode() {
    var params = new URLSearchParams(window.location.search);
    return window.location.pathname === PRODUCT_PATH &&
      params.get('review') !== '1' &&
      !document.body.classList.contains('myx-review-open') &&
      !document.body.classList.contains('myx-review-pending') &&
      !document.querySelector('#myx-design-review:not([hidden])');
  }

  function usesDesktopEmbeddedPreview() {
    return !!(window.matchMedia && window.matchMedia(DESKTOP_EMBED_QUERY).matches && desktopPreviewHost());
  }

  function desktopPreviewHost() {
    var viewerRoot = document.querySelector('#product-builder #viewer-3d-root');
    return (viewerRoot && viewerRoot.closest('.cpb-preview-container')) ||
      (viewerRoot && viewerRoot.closest('.cpb-preview-wrapper')) ||
      document.querySelector('#product-builder .cpb-preview-container') ||
      document.querySelector('#product-builder .cpb-preview-wrapper') ||
      null;
  }

  function clearEmbeddedBounds() {
    if (!controller.dialog) return;
    ['left', 'top', 'width', 'height'].forEach(function (property) {
      controller.dialog.style.removeProperty(property);
    });
  }

  function syncEmbeddedBounds() {
    controller.embeddedBoundsFrame = 0;
    if (!controller.embedded || !controller.dialog || controller.dialog.hidden) return;
    var host = desktopPreviewHost();
    if (!host || !host.isConnected) return;
    if (controller.embeddedHost !== host) {
      if (controller.embeddedResizeObserver) controller.embeddedResizeObserver.disconnect();
      controller.embeddedHost = host;
      if (controller.embeddedResizeObserver) controller.embeddedResizeObserver.observe(host);
    }
    var rect = host.getBoundingClientRect();
    var left = Math.max(0, rect.left);
    var top = Math.max(0, rect.top);
    var right = Math.min(window.innerWidth, rect.right);
    var bottom = Math.min(window.innerHeight, rect.bottom);
    controller.dialog.style.left = Math.round(left) + 'px';
    controller.dialog.style.top = Math.round(top) + 'px';
    controller.dialog.style.width = Math.max(0, Math.round(right - left)) + 'px';
    controller.dialog.style.height = Math.max(0, Math.round(bottom - top)) + 'px';
  }

  function scheduleEmbeddedBoundsSync() {
    if (!controller.embedded || controller.embeddedBoundsFrame) return;
    controller.embeddedBoundsFrame = window.requestAnimationFrame(syncEmbeddedBounds);
  }

  function teardownEmbeddedTracking() {
    if (controller.embeddedBoundsFrame) window.cancelAnimationFrame(controller.embeddedBoundsFrame);
    controller.embeddedBoundsFrame = 0;
    if (controller.embeddedScrollHandler) {
      window.removeEventListener('scroll', controller.embeddedScrollHandler, true);
      controller.embeddedScrollHandler = null;
    }
    if (controller.embeddedResizeObserver) {
      controller.embeddedResizeObserver.disconnect();
      controller.embeddedResizeObserver = null;
    }
    controller.embeddedHost = null;
    clearEmbeddedBounds();
  }

  function setPreviewLayoutMode(embedded) {
    if (!controller.dialog) return;
    if (embedded) {
      controller.embedded = true;
      controller.dialog.setAttribute('data-myx-room-mode', 'embedded');
      controller.dialog.setAttribute('role', 'region');
      controller.dialog.removeAttribute('aria-modal');
      controller.dialog.removeAttribute('aria-labelledby');
      controller.dialog.setAttribute('aria-label', 'Room preview');
      controller.dialog.querySelector('.myx-room-preview__close').setAttribute('aria-label', 'Back to 3D preview');
      document.body.classList.add('myx-room-open--embedded');
      document.body.style.overflow = controller.previousBodyOverflow || '';
      if (!controller.embeddedScrollHandler) {
        controller.embeddedScrollHandler = scheduleEmbeddedBoundsSync;
        window.addEventListener('scroll', controller.embeddedScrollHandler, true);
      }
      if (!controller.embeddedResizeObserver && typeof ResizeObserver === 'function') {
        controller.embeddedResizeObserver = new ResizeObserver(scheduleEmbeddedBoundsSync);
      }
      syncEmbeddedBounds();
      return;
    }
    teardownEmbeddedTracking();
    controller.embedded = false;
    controller.dialog.setAttribute('data-myx-room-mode', 'fullscreen');
    controller.dialog.setAttribute('role', 'dialog');
    controller.dialog.setAttribute('aria-modal', 'true');
    controller.dialog.removeAttribute('aria-label');
    controller.dialog.setAttribute('aria-labelledby', 'myx-room-preview-title');
    controller.dialog.querySelector('.myx-room-preview__close').setAttribute('aria-label', 'Close room preview');
    document.body.classList.remove('myx-room-open--embedded');
    document.body.style.overflow = 'hidden';
  }

  function svgRoomIcon() {
    return '<span class="myx-eye-icon" aria-hidden="true"></span>';
  }

  function svgCloseIcon() {
    return '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  }

  function svgDragIcon() {
    return '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 3v18m0-18-3 3m3-3 3 3m-3 15-3-3m3 3 3-3M3 12h18M3 12l3-3m-3 3 3 3m15-3-3-3m3 3-3 3" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  function svgBulbIcon() {
    return '<span class="myx-power-icon" aria-hidden="true"></span>';
  }

  function svgUploadIcon() {
    return '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 16V4m0 0L7.5 8.5M12 4l4.5 4.5M5 14v4.5A1.5 1.5 0 0 0 6.5 20h11a1.5 1.5 0 0 0 1.5-1.5V14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  function svgCameraIcon() {
    return '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 7.5h3l1.4-2h7.2l1.4 2h3v11H4v-11Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/><circle cx="12" cy="13" r="3.2" stroke="currentColor" stroke-width="1.7"/></svg>';
  }

  function svgPhotoIcon() {
    return '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="3.5" y="4.5" width="17" height="15" rx="2" stroke="currentColor" stroke-width="1.7"/><path d="m5.5 17 4.2-4.2 2.8 2.6 2.2-2.2 3.8 3.8" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/><circle cx="15.8" cy="9.2" r="1.4" fill="currentColor"/></svg>';
  }

  function track(eventName, properties) {
    var detail = Object.assign({ event: eventName, source: 'builder_room_preview' }, properties || {});
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(detail);
    } catch (error) { /* analytics must never interrupt the preview */ }
    try {
      document.dispatchEvent(new CustomEvent('maytrix:room-preview-analytics', { detail: detail }));
    } catch (error) { /* CustomEvent is optional */ }
  }

  function revealCta() {
    if (!controller.cta || !controller.ctaWrapper || !isBuilderMode()) return;
    controller.ctaTransitionPending = false;
    controller.ctaTransitioning = false;
    controller.ctaRevealed = true;
    window.clearTimeout(controller.ctaTimer);
    window.clearTimeout(controller.ctaFadeTimer);
    controller.ctaTimer = 0;
    controller.ctaFadeTimer = 0;
    controller.ctaWrapper.classList.remove('myx-room-hint-fading', 'myx-room-hint-hidden');
    controller.ctaWrapper.classList.add('myx-room-cta-ready');
    controller.cta.classList.add('is-ready');
  }

  function scheduleCtaReveal() {
    if (!controller.builderReady || !controller.cta) return;
    revealCta();
  }

  function markBuilderReady() {
    if (!isBuilderMode()) return;
    if (controller.builderReady) {
      mountCta();
      scheduleCtaReveal();
      return;
    }
    controller.builderReady = true;
    controller.ctaRevealDueAt = 0;
    window.clearInterval(controller.readinessTimer);
    controller.readinessTimer = 0;
    mountCta();
    scheduleCtaReveal();
  }

  function bindWrapperInteractions(wrapper) {
    if (!wrapper || wrapper.getAttribute('data-myx-room-interactions') === 'ready') return;
    wrapper.setAttribute('data-myx-room-interactions', 'ready');

    wrapper.addEventListener('pointerdown', function (event) {
      if (event.target && event.target.closest && event.target.closest('[data-myx-room-preview-cta]')) return;
      controller.builderInteracting = true;
    }, true);

    function finishInteraction() {
      controller.builderInteracting = false;
      if (controller.ctaTransitionPending) revealCta();
    }

    wrapper.addEventListener('pointerup', finishInteraction, true);
    wrapper.addEventListener('pointercancel', finishInteraction, true);
    wrapper.addEventListener('lostpointercapture', finishInteraction, true);
  }

  function launchFromCta(button) {
    button.setAttribute('data-myx-room-clicked', 'true');
    Promise.resolve(openDialog()).catch(function (error) {
      button.setAttribute('data-myx-room-error', String(error && error.message || error));
      console.error('[Maytrix room preview] Unable to open the room preview.', error);
    });
  }

  function handleDelegatedCtaClick(event) {
    var target = event.target;
    var button = target && target.closest ? target.closest('[data-myx-room-preview-cta]') : null;
    if (!button || !isBuilderMode()) return;
    event.preventDefault();
    launchFromCta(button);
  }

  function bindCta(button) {
    button.setAttribute('data-myx-room-runtime', 'ready');
  }

  function mountCta() {
    syncBuilderSizePresentation();
    if (!isBuilderMode()) {
      closeDialog('review');
      return;
    }
    var legacyWrapper = document.querySelector('#product-builder .cpb-preview-wrapper');
    if (legacyWrapper) legacyWrapper.setAttribute('data-myx-room-legacy-hint', 'hidden');
    var viewerRoot = document.querySelector('#product-builder #viewer-3d-root');
    var wrapper = (viewerRoot && viewerRoot.closest('.cpb-preview-container')) || viewerRoot || legacyWrapper;
    if (!wrapper) return;
    bindWrapperInteractions(wrapper);
    Array.prototype.forEach.call(wrapper.querySelectorAll('[data-myx-room-preview-hint]'), function (hint) { hint.remove(); });
    controller.hint = null;
    var existing = wrapper.querySelector('[data-myx-room-preview-cta]');
    if (existing) {
      bindCta(existing);
      controller.cta = existing;
      controller.ctaWrapper = wrapper;
      if (controller.ctaRevealed) {
        wrapper.classList.remove('myx-room-hint-fading');
        wrapper.classList.add('myx-room-hint-hidden', 'myx-room-cta-ready');
        existing.classList.add('is-ready');
      } else if (controller.ctaTransitioning) {
        wrapper.classList.add('myx-room-hint-fading');
        existing.classList.remove('is-ready');
      } else if (controller.builderReady && !controller.ctaTimer) {
        scheduleCtaReveal();
      }
      return;
    }

    if (controller.cta && controller.cta.isConnected) controller.cta.remove();
    if (controller.ctaWrapper && controller.ctaWrapper !== wrapper) {
      controller.ctaWrapper.classList.remove('myx-room-hint-fading', 'myx-room-hint-hidden', 'myx-room-cta-ready');
    }

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'myx-room-preview-cta';
    button.setAttribute('data-myx-room-preview-cta', '');
    button.setAttribute('aria-label', 'Preview your infinity mirror sign in a room');
    button.innerHTML = svgRoomIcon() + '<span>Preview My Sign</span>';
    bindCta(button);
    wrapper.appendChild(button);

    controller.cta = button;
    controller.ctaWrapper = wrapper;
    if (controller.ctaRevealed) {
      wrapper.classList.add('myx-room-hint-hidden', 'myx-room-cta-ready');
      button.classList.add('is-ready');
    } else if (controller.ctaTransitioning) {
      wrapper.classList.add('myx-room-hint-fading');
    } else if (controller.builderReady) {
      scheduleCtaReveal();
    }

    var preview = wrapper.querySelector('#viewer-3d-root .canvas-wrap') || wrapper.querySelector('#viewer-3d-root');
    if (preview) {
      preview.addEventListener('pointerup', markBuilderReady, { once: true, passive: true });
    }
  }

  function buildDialog() {
    if (controller.dialog) return controller.dialog;

    var dialog = document.createElement('section');
    dialog.className = 'myx-room-preview';
    dialog.hidden = true;
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    dialog.setAttribute('aria-labelledby', 'myx-room-preview-title');
    dialog.innerHTML = [
      '<header class="myx-room-preview__topbar">',
      '  <button class="myx-room-preview__close" type="button" aria-label="Close room preview">' + svgCloseIcon() + '<span class="myx-room-preview__back-label">Back to 3D</span></button>',
      '  <div class="myx-room-preview__heading">',
      '    <span class="myx-room-preview__eyebrow">Your Maytrix design</span>',
      '    <h2 class="myx-room-preview__title" id="myx-room-preview-title">See It in a Room</h2>',
      '  </div>',
      '  <div class="myx-room-preview__size-control">',
      '    <button class="myx-room-preview__size" data-myx-room-size type="button" aria-haspopup="dialog" aria-expanded="false" aria-controls="myx-room-size-sheet">',
      '      <span class="myx-room-preview__size-prefix">Size</span><span aria-hidden="true">·</span><span data-myx-room-size-value>Preview</span><span class="myx-room-preview__size-chevron" aria-hidden="true"></span>',
      '    </button>',
      '    <span class="myx-room-preview__size-hint" data-myx-room-size-hint role="status" hidden>Tap Size to compare</span>',
      '  </div>',
      '</header>',
      '<div class="myx-room-preview__stage-wrap">',
      '  <div class="myx-room-preview__stage" data-myx-room-stage>',
      '    <img class="myx-room-preview__scene-image" alt="" data-myx-room-scene>',
      '    <div class="myx-room-preview__mirror" data-myx-room-mirror hidden>',
      '      <img class="myx-room-preview__mirror-art myx-room-preview__mirror-art--on" alt="Your customized infinity mirror" draggable="false" data-myx-room-art>',
      '      <img class="myx-room-preview__mirror-art myx-room-preview__mirror-art--off" alt="Your customized mirror with the infinity lights off" draggable="false" data-myx-room-art-off>',
      '    </div>',
      '    <div class="myx-room-preview__loading" data-myx-room-loading>',
      '      <div class="myx-room-preview__spinner" aria-hidden="true"></div>',
      '      <p>Preparing your room preview…</p>',
      '    </div>',
      '    <div class="myx-room-preview__error" data-myx-room-error hidden>',
      '      <p>The design preview is still loading. Close this view, wait a moment, and try again.</p>',
      '    </div>',
      '    <div class="myx-room-preview__tip" data-myx-room-tip>' + svgDragIcon() + '<span>Drag to reposition</span></div>',
      '    <div class="myx-room-preview__photo-status" data-myx-room-photo-status role="status" aria-live="polite" hidden></div>',
      '    <div class="myx-room-preview__custom-guidance">',
      '      <strong>Manual scaling required</strong>',
      '      <span>This photo preview can’t determine exact scale. Use your own wall measurements to resize the mockup.</span>',
      '      <span>Take the photo straight-on, centered on the wall, for the best mockup alignment.</span>',
      '    </div>',
      '    <section class="myx-room-preview__custom-tools" data-myx-room-custom-tools aria-label="Uploaded room photo controls" hidden>',
      '      <div class="myx-room-preview__custom-scale">',
      '        <button type="button" data-myx-room-scale-down aria-label="Make the mockup smaller">−</button>',
      '        <label><span>Mockup size</span><input data-myx-room-scale type="range" min="' + CUSTOM_SCALE_MIN + '" max="' + CUSTOM_SCALE_MAX + '" step="' + CUSTOM_SCALE_STEP + '" value="100" aria-label="Mockup size"><output data-myx-room-scale-output>100%</output></label>',
      '        <button type="button" data-myx-room-scale-up aria-label="Make the mockup larger">+</button>',
      '      </div>',
      '      <div class="myx-room-preview__custom-actions">',
      '        <button type="button" data-myx-room-reset>Reset</button>',
      '        <button type="button" data-myx-room-replace>Replace</button>',
      '        <button type="button" data-myx-room-remove>Remove</button>',
      '      </div>',
      '    </section>',
      '    <div class="myx-room-preview__floating-controls">',
      '      <div class="myx-room-preview__rooms" role="group" aria-label="Choose a room"></div>',
      '      <button class="myx-room-preview__light is-on" data-myx-room-light type="button" aria-pressed="true" aria-label="Turn infinity mirror off" hidden>' + svgBulbIcon() + '</button>',
      '    </div>',
      '  </div>',
      '  <div class="myx-room-preview__photo-sheet" data-myx-room-photo-sheet role="dialog" aria-modal="true" aria-labelledby="myx-room-photo-title" hidden>',
      '    <button class="myx-room-preview__photo-sheet-backdrop" type="button" data-myx-room-photo-cancel aria-label="Close photo options"></button>',
      '    <section class="myx-room-preview__photo-sheet-card">',
      '      <div class="myx-room-preview__photo-sheet-handle" aria-hidden="true"></div>',
      '      <h3 id="myx-room-photo-title">Use Your Own Room</h3>',
      '      <p>Take the photo straight-on, centered on the wall, for the best mockup alignment.</p>',
      '      <div class="myx-room-preview__photo-scale-note"><strong>Manual scaling required</strong><span>This photo preview can’t determine exact scale. Use your own wall measurements to resize the mockup.</span></div>',
      '      <div class="myx-room-preview__photo-mobile-actions">',
      '        <button type="button" data-myx-room-camera>' + svgCameraIcon() + '<span>Take a Photo</span></button>',
      '        <button type="button" data-myx-room-library>' + svgPhotoIcon() + '<span>Choose from Photo Library</span></button>',
      '      </div>',
      '      <button class="myx-room-preview__photo-desktop-action" type="button" data-myx-room-computer>' + svgUploadIcon() + '<span>Upload from Computer</span></button>',
      '      <button class="myx-room-preview__photo-sheet-cancel" type="button" data-myx-room-photo-cancel>Cancel</button>',
      '    </section>',
      '  </div>',
      '  <div class="myx-room-preview__size-sheet" id="myx-room-size-sheet" data-myx-room-size-sheet role="dialog" aria-modal="true" aria-labelledby="myx-room-size-title" hidden>',
      '    <button class="myx-room-preview__size-sheet-backdrop" type="button" data-myx-room-size-cancel aria-label="Close size comparison"></button>',
      '    <section class="myx-room-preview__size-sheet-card">',
      '      <div class="myx-room-preview__size-sheet-handle" aria-hidden="true"></div>',
      '      <div class="myx-room-preview__size-sheet-heading">',
      '        <div><span>Signature Sizes</span><h3 id="myx-room-size-title">Compare Sizes</h3></div>',
      '        <button class="myx-room-preview__size-sheet-close" type="button" data-myx-room-size-cancel aria-label="Close size comparison">' + svgCloseIcon() + '</button>',
      '      </div>',
      '      <p>Tap a size to preview it in this room. Your design and price change only after you apply it.</p>',
      '      <div class="myx-room-preview__size-choices" data-myx-room-size-choices role="group" aria-label="Signature Sizes"></div>',
      '      <div class="myx-room-preview__size-status" data-myx-room-size-status role="status" aria-live="polite"></div>',
      '      <div class="myx-room-preview__size-actions">',
      '        <button class="myx-room-preview__size-cancel" type="button" data-myx-room-size-cancel>Keep Current</button>',
      '        <button class="myx-room-preview__size-apply" type="button" data-myx-room-size-apply disabled>Use This Size</button>',
      '      </div>',
      '      <button class="myx-room-preview__size-custom" type="button" data-myx-room-size-custom>Edit Custom Size in Builder</button>',
      '    </section>',
      '  </div>',
      '  <input type="file" accept="image/jpeg,image/png,image/webp,image/heic,image/heif" data-myx-room-photo-input hidden>',
      '  <input type="file" accept="image/*" capture="environment" data-myx-room-camera-input hidden>',
      '  <input type="file" accept="image/*" data-myx-room-library-input hidden>',
      '</div>'
    ].join('');

    controller.dialog = dialog;
    controller.stage = dialog.querySelector('[data-myx-room-stage]');
    controller.sceneImage = dialog.querySelector('[data-myx-room-scene]');
    controller.mirror = dialog.querySelector('[data-myx-room-mirror]');
    controller.mirrorArt = dialog.querySelector('[data-myx-room-art]');
    controller.mirrorArtOff = dialog.querySelector('[data-myx-room-art-off]');
    controller.lightButton = dialog.querySelector('[data-myx-room-light]');
    controller.loading = dialog.querySelector('[data-myx-room-loading]');
    controller.error = dialog.querySelector('[data-myx-room-error]');
    controller.sizeBadge = dialog.querySelector('[data-myx-room-size]');
    controller.sizeBadgeValue = dialog.querySelector('[data-myx-room-size-value]');
    controller.sizeHint = dialog.querySelector('[data-myx-room-size-hint]');
    controller.sizeSheet = dialog.querySelector('[data-myx-room-size-sheet]');
    controller.sizeChoices = dialog.querySelector('[data-myx-room-size-choices]');
    controller.sizeStatus = dialog.querySelector('[data-myx-room-size-status]');
    controller.sizeApplyButton = dialog.querySelector('[data-myx-room-size-apply]');
    controller.tip = dialog.querySelector('[data-myx-room-tip]');
    controller.customPhotoStatus = dialog.querySelector('[data-myx-room-photo-status]');
    controller.customPhotoSheet = dialog.querySelector('[data-myx-room-photo-sheet]');
    controller.customControls = dialog.querySelector('[data-myx-room-custom-tools]');
    controller.customScaleInput = dialog.querySelector('[data-myx-room-scale]');
    controller.customScaleOutput = dialog.querySelector('[data-myx-room-scale-output]');
    controller.customPhotoInput = dialog.querySelector('[data-myx-room-photo-input]');
    controller.customCameraInput = dialog.querySelector('[data-myx-room-camera-input]');
    controller.customLibraryInput = dialog.querySelector('[data-myx-room-library-input]');

    dialog.querySelector('.myx-room-preview__close').addEventListener('click', function () { closeDialog('close_button'); });
    controller.sizeBadge.addEventListener('click', openSizeSheet);
    Array.prototype.forEach.call(dialog.querySelectorAll('[data-myx-room-size-cancel]'), function (button) {
      button.addEventListener('click', function () { closeSizeSheet(true, true); });
    });
    controller.sizeApplyButton.addEventListener('click', applyComparedSize);
    dialog.querySelector('[data-myx-room-size-custom]').addEventListener('click', editCustomSizeInBuilder);
    controller.lightButton.addEventListener('click', function () {
      setMirrorPower(!controller.mirrorPowered, true);
    });
    dialog.addEventListener('pointerdown', function (event) {
      if (event.target === dialog) closeDialog('backdrop');
    });

    var roomList = dialog.querySelector('.myx-room-preview__rooms');
    rooms.forEach(function (room) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'myx-room-preview__room';
      button.setAttribute('data-room-id', room.id);
      button.setAttribute('aria-pressed', room.id === controller.activeRoom.id ? 'true' : 'false');
      button.setAttribute('aria-label', 'Preview in ' + room.label);
      button.title = room.label;
      var thumb = document.createElement('img');
      thumb.alt = '';
      thumb.loading = 'lazy';
      thumb.decoding = 'async';
      // Only small thumbnails load here. selectRoom loads the selected responsive scene.
      thumb.src = room.thumb || room.image || '';
      var label = document.createElement('span');
      label.textContent = room.label;
      button.appendChild(thumb);
      button.appendChild(label);
      button.addEventListener('click', function () { selectRoom(room.id, true); });
      roomList.appendChild(button);
      controller.roomButtons.push(button);
    });

    var uploadButton = document.createElement('button');
    uploadButton.type = 'button';
    uploadButton.className = 'myx-room-preview__room myx-room-preview__room--upload';
    uploadButton.setAttribute('data-room-id', customRoom.id);
    uploadButton.setAttribute('aria-pressed', 'false');
    uploadButton.setAttribute('aria-label', 'Upload your own room photo from this computer');
    uploadButton.title = 'Upload your own room photo';
    uploadButton.innerHTML = '<span class="myx-room-preview__upload-icon">' + svgUploadIcon() + '</span><span class="myx-room-preview__upload-label">Upload</span>';
    uploadButton.addEventListener('click', function () {
      if (controller.customPhotoUrl) selectRoom(customRoom.id, true);
      else requestCustomRoomPhoto();
    });
    roomList.appendChild(uploadButton);
    controller.customPhotoButton = uploadButton;
    controller.roomButtons.push(uploadButton);
    updateCustomPhotoButton();

    Array.prototype.forEach.call(dialog.querySelectorAll('[data-myx-room-photo-cancel]'), function (button) {
      button.addEventListener('click', closeCustomPhotoSheet);
    });
    dialog.querySelector('[data-myx-room-camera]').addEventListener('click', function () {
      closeCustomPhotoSheet();
      controller.customCameraInput.click();
    });
    dialog.querySelector('[data-myx-room-library]').addEventListener('click', function () {
      closeCustomPhotoSheet();
      controller.customLibraryInput.click();
    });
    dialog.querySelector('[data-myx-room-computer]').addEventListener('click', function () {
      closeCustomPhotoSheet();
      controller.customPhotoInput.click();
    });
    bindPhotoInput(controller.customPhotoInput, 'computer');
    bindPhotoInput(controller.customCameraInput, 'camera');
    bindPhotoInput(controller.customLibraryInput, 'library');

    controller.customScaleInput.addEventListener('input', function () {
      setCustomScale(Number(controller.customScaleInput.value), true);
    });
    dialog.querySelector('[data-myx-room-scale-down]').addEventListener('click', function () {
      setCustomScale(controller.customScale - CUSTOM_SCALE_STEP, true);
    });
    dialog.querySelector('[data-myx-room-scale-up]').addEventListener('click', function () {
      setCustomScale(controller.customScale + CUSTOM_SCALE_STEP, true);
    });
    dialog.querySelector('[data-myx-room-reset]').addEventListener('click', resetCustomRoomPlacement);
    dialog.querySelector('[data-myx-room-replace]').addEventListener('click', requestCustomRoomPhoto);
    dialog.querySelector('[data-myx-room-remove]').addEventListener('click', removeCustomRoomPhoto);

    controller.mirror.addEventListener('pointerdown', beginDrag);
    controller.mirror.addEventListener('pointermove', moveDrag);
    controller.mirror.addEventListener('pointerup', endDrag);
    controller.mirror.addEventListener('pointercancel', endDrag);

    document.body.appendChild(dialog);
    return dialog;
  }

  function isMobilePhotoChoice() {
    return !!(window.matchMedia && window.matchMedia('(max-width: 640px)').matches);
  }

  function requestCustomRoomPhoto() {
    if (!controller.dialog) buildDialog();
    if (isMobilePhotoChoice()) {
      controller.customPhotoSheetOpener = document.activeElement;
      controller.customPhotoSheet.hidden = false;
      controller.dialog.classList.add('is-photo-sheet-open');
      var first = controller.customPhotoSheet.querySelector('[data-myx-room-camera]');
      if (first) first.focus({ preventScroll: true });
      return;
    }
    controller.customPhotoInput.value = '';
    controller.customPhotoInput.click();
  }

  function closeCustomPhotoSheet(restoreFocus) {
    if (!controller.customPhotoSheet || controller.customPhotoSheet.hidden) return;
    controller.customPhotoSheet.hidden = true;
    controller.dialog.classList.remove('is-photo-sheet-open');
    if (restoreFocus !== false && controller.customPhotoSheetOpener && controller.customPhotoSheetOpener.focus && controller.customPhotoSheetOpener.isConnected) {
      controller.customPhotoSheetOpener.focus({ preventScroll: true });
    }
    controller.customPhotoSheetOpener = null;
  }

  function copyDimensions(dimensions) {
    if (!dimensions) return null;
    return {
      shape: dimensions.shape,
      width: dimensions.width,
      height: dimensions.height,
      unit: dimensions.unit,
      widthInches: dimensions.widthInches,
      heightInches: dimensions.heightInches,
      label: dimensions.label
    };
  }

  function compactSizeNumber(number) {
    return String(parseFloat(Number(number).toFixed(1)));
  }

  function cleanWholeNumber(number) {
    var value = Number(number);
    if (!Number.isFinite(value)) return null;
    var rounded = Math.round(value);
    return Math.abs(value - rounded) <= 0.01 ? rounded : null;
  }

  function feetAxisLabel(inches) {
    return compactSizeNumber(Number(inches) / 12);
  }

  function feetAxisAria(inches) {
    var feet = Number(inches) / 12;
    return compactSizeNumber(feet) + (Math.abs(feet - 1) <= 0.001 ? ' foot' : ' feet');
  }

  function formatDimensionsForDisplay(dimensions) {
    if (!dimensions) return { primary: 'Preview', compact: 'Preview', exact: '', aria: 'Preview size' };
    var unit = String(dimensions.unit || 'in').toLowerCase();
    var width = Number(dimensions.width);
    var height = Number(dimensions.height);
    var exact = dimensions.label || (compactSizeNumber(width) + ' × ' + compactSizeNumber(height) + ' ' + unit);
    var widthWhole = unit === 'in' ? cleanWholeNumber(width) : null;
    var heightWhole = unit === 'in' ? cleanWholeNumber(height) : null;
    var useFeet = widthWhole != null && heightWhole != null &&
      widthWhole % 6 === 0 && heightWhole % 6 === 0 &&
      (widthWhole >= 12 || heightWhole >= 12);
    if (!useFeet) {
      return {
        primary: exact,
        compact: compactSizeNumber(width) + '×' + compactSizeNumber(height) + ' ' + unit.toUpperCase(),
        exact: exact,
        aria: compactSizeNumber(width) + ' by ' + compactSizeNumber(height) + ' ' + (unit === 'cm' ? 'centimeters' : 'inches')
      };
    }

    return {
      primary: feetAxisLabel(widthWhole) + ' × ' + feetAxisLabel(heightWhole) + ' ft',
      compact: feetAxisLabel(widthWhole) + '×' + feetAxisLabel(heightWhole) + ' FT',
      exact: exact,
      aria: feetAxisAria(widthWhole) + ' by ' + feetAxisAria(heightWhole)
    };
  }

  function sizeButtonText(dimensions) {
    return formatDimensionsForDisplay(dimensions).compact;
  }

  function syncBuilderSizePresentation() {
    if (!isBuilderMode()) return;
    var selector = '.myx-customizer-mobilebar [data-myx-customizer-size], .myx-customizer-desktopbar [data-myx-customizer-size]';
    Array.prototype.forEach.call(document.querySelectorAll(selector), function (element) {
      var source = String(element.textContent || '').trim();
      var match = source.match(/(\d+(?:\.\d+)?)\s*[×x]\s*(\d+(?:\.\d+)?)\s*(in|cm)\b/i);
      var state = currentViewerState();
      var custom = /custom|manual/i.test(String(state.sizeMode || ''));
      var stateReady = !!String(state.shape || '').trim() && (custom
        ? !!(positiveNumber(state.sizeCustomWidth) && positiveNumber(state.sizeCustomLength))
        : !!positiveNumber(state.size));
      var dimensions = stateReady ? currentDimensions(state) : (match ? {
        width: Number(match[1]),
        height: Number(match[2]),
        unit: match[3].toLowerCase(),
        label: compactSizeNumber(match[1]) + ' × ' + compactSizeNumber(match[2]) + ' ' + match[3].toLowerCase()
      } : null);
      if (!dimensions) return;
      var display = formatDimensionsForDisplay(dimensions);
      var desired = display.primary + ' • Shipping included';
      if (element.textContent !== desired) element.textContent = desired;
      element.setAttribute('aria-label', 'Selected size ' + display.aria + '. Shipping included.');
    });
  }

  function sameDimensions(left, right) {
    if (!left || !right) return false;
    return Math.abs(Number(left.widthInches) - Number(right.widthInches)) < 0.1 &&
      Math.abs(Number(left.heightInches) - Number(right.heightInches)) < 0.1;
  }

  function dimensionsFromChoice(choice, shape) {
    var width = Number(choice && choice.width) || 24;
    var height = Number(choice && choice.height) || width;
    return {
      shape: canonicalShape(shape),
      width: width,
      height: height,
      unit: 'in',
      widthInches: width,
      heightInches: height,
      label: compactSizeNumber(width) + ' × ' + compactSizeNumber(height) + ' in'
    };
  }

  function updateSizeBadge(dimensions, previewing) {
    if (!controller.sizeBadge || !dimensions) return;
    var display = formatDimensionsForDisplay(dimensions);
    controller.sizeBadgeValue.textContent = sizeButtonText(dimensions);
    controller.sizeBadge.setAttribute('aria-label', (previewing ? 'Previewing size ' : 'Selected size ') + display.aria + '. Compare Signature Sizes');
    controller.sizeBadge.classList.toggle('is-previewing', !!previewing);
  }

  function signatureSizeAdapter() {
    var adapter = window.__MAYTRIX_SIGNATURE_SIZES__;
    return adapter && typeof adapter.getChoices === 'function' && typeof adapter.commit === 'function' ? adapter : null;
  }

  function setSizeStatus(message, state) {
    if (!controller.sizeStatus) return;
    controller.sizeStatus.textContent = message || '';
    controller.sizeStatus.classList.toggle('is-error', state === 'error');
    controller.sizeStatus.classList.toggle('is-success', state === 'success');
  }

  function renderSizeChoices() {
    if (!controller.sizeChoices) return;
    controller.sizeChoices.textContent = '';
    var choices = controller.availableSizeChoices || [];
    choices.forEach(function (choice, index) {
      var dimensions = dimensionsFromChoice(choice, controller.sizeCommittedDimensions && controller.sizeCommittedDimensions.shape || controller.dimensions.shape);
      var display = formatDimensionsForDisplay(dimensions);
      var isCurrent = sameDimensions(dimensions, controller.sizeCommittedDimensions);
      var isPreviewing = controller.sizeCandidate === choice;
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'myx-room-preview__size-choice';
      button.classList.toggle('is-current', isCurrent);
      button.classList.toggle('is-previewing', isPreviewing);
      button.setAttribute('aria-pressed', isPreviewing || (!controller.sizeCandidate && isCurrent) ? 'true' : 'false');
      button.setAttribute('data-myx-room-size-index', String(index));
      var name = document.createElement('strong');
      name.textContent = choice.name;
      var measurement = document.createElement('span');
      measurement.className = 'myx-room-preview__size-choice-measurement';
      measurement.textContent = display.primary;
      if (display.primary !== display.exact) {
        var exact = document.createElement('span');
        exact.className = 'myx-room-preview__size-choice-exact';
        exact.textContent = display.exact;
        measurement.appendChild(exact);
      }
      var note = document.createElement('span');
      note.className = 'myx-room-preview__size-choice-note';
      note.textContent = isPreviewing ? 'Previewing' : (isCurrent ? 'Current size' : 'Price updates when applied');
      button.appendChild(name);
      button.appendChild(measurement);
      button.appendChild(note);
      button.setAttribute('aria-label', choice.name + ', ' + display.aria + (isCurrent ? ', current size' : ''));
      button.addEventListener('click', function () { previewComparedSize(choice); });
      controller.sizeChoices.appendChild(button);
    });
  }

  function previewComparedSize(choice) {
    if (!choice || controller.sizeCommitLock) return;
    controller.sizeCandidate = choice;
    controller.dimensions = dimensionsFromChoice(choice, controller.sizeCommittedDimensions.shape);
    updateSizeBadge(controller.dimensions, !sameDimensions(controller.dimensions, controller.sizeCommittedDimensions));
    updateMirrorLayout();
    renderSizeChoices();
    var focusedChoice = controller.sizeChoices.querySelector('[data-myx-room-size-index="' + String(controller.availableSizeChoices.indexOf(choice)) + '"]');
    if (focusedChoice) focusedChoice.focus({ preventScroll: true });
    var unchanged = sameDimensions(controller.dimensions, controller.sizeCommittedDimensions);
    controller.sizeApplyButton.disabled = unchanged;
    controller.sizeApplyButton.textContent = unchanged ? 'Current Size' : 'Use This Size';
    setSizeStatus(unchanged ? 'This is your current Signature Size.' : 'Previewing ' + controller.dimensions.label + '. Price updates when applied.');
    track('size_previewed', {
      room: controller.activeRoom.id,
      shape: controller.dimensions.shape,
      from_size: controller.sizeCommittedDimensions.label,
      to_size: controller.dimensions.label
    });
  }

  function openSizeSheet() {
    if (!controller.sizeSheet || controller.sizeCommitLock) return;
    var adapter = signatureSizeAdapter();
    if (!adapter) {
      if (controller.sizeHint) {
        controller.sizeHint.textContent = 'Sizes are loading — try again';
        controller.sizeHint.hidden = false;
        window.clearTimeout(controller.sizeHintTimer);
        controller.sizeHintTimer = window.setTimeout(function () {
          if (controller.sizeHint) {
            controller.sizeHint.hidden = true;
            controller.sizeHint.textContent = 'Tap Size to compare';
          }
        }, 3200);
      }
      return;
    }
    controller.sizeSheetOpener = document.activeElement;
    controller.availableSizeChoices = adapter.getChoices(controller.sizeCommittedDimensions.shape) || [];
    controller.sizeCandidate = null;
    controller.sizeApplyButton.disabled = true;
    controller.sizeApplyButton.textContent = 'Use This Size';
    setSizeStatus('Choose a Signature Size to preview.');
    renderSizeChoices();
    controller.sizeSheet.hidden = false;
    controller.sizeBadge.setAttribute('aria-expanded', 'true');
    controller.dialog.classList.add('is-size-sheet-open');
    setRoomBackgroundInert(true);
    if (controller.sizeHint) controller.sizeHint.hidden = true;
    window.clearTimeout(controller.sizeHintTimer);
    var selected = controller.sizeChoices.querySelector('[aria-pressed="true"]') || controller.sizeChoices.querySelector('button');
    if (selected) selected.focus({ preventScroll: true });
    track('size_compare_opened', {
      room: controller.activeRoom.id,
      shape: controller.sizeCommittedDimensions.shape,
      size: controller.sizeCommittedDimensions.label
    });
  }

  function closeSizeSheet(restorePreview, restoreFocus) {
    if (!controller.sizeSheet || controller.sizeSheet.hidden || controller.sizeCommitLock) return;
    if (restorePreview !== false && controller.sizeCommittedDimensions) {
      controller.dimensions = copyDimensions(controller.sizeCommittedDimensions);
      updateSizeBadge(controller.dimensions, false);
      updateMirrorLayout();
    }
    controller.sizeSheet.hidden = true;
    controller.sizeBadge.setAttribute('aria-expanded', 'false');
    controller.dialog.classList.remove('is-size-sheet-open');
    setRoomBackgroundInert(false);
    controller.sizeCandidate = null;
    setSizeStatus('');
    if (restoreFocus !== false && controller.sizeSheetOpener && controller.sizeSheetOpener.focus && controller.sizeSheetOpener.isConnected) {
      controller.sizeSheetOpener.focus({ preventScroll: true });
    }
    controller.sizeSheetOpener = null;
  }

  function syncCommittedSizeFromCustomizer(fallbackChoice) {
    var adapter = signatureSizeAdapter();
    var selected = adapter && typeof adapter.getSelection === 'function' ? adapter.getSelection(controller.sizeCommittedDimensions.shape) : null;
    var dimensions = selected ? dimensionsFromChoice(selected, controller.sizeCommittedDimensions.shape) : currentDimensions();
    if (fallbackChoice && !sameDimensions(dimensions, dimensionsFromChoice(fallbackChoice, controller.sizeCommittedDimensions.shape))) {
      dimensions = dimensionsFromChoice(fallbackChoice, controller.sizeCommittedDimensions.shape);
    }
    controller.sizeCommittedDimensions = copyDimensions(dimensions);
    controller.dimensions = copyDimensions(dimensions);
    updateSizeBadge(controller.dimensions, false);
    updateMirrorLayout();
    return dimensions;
  }

  function setRoomBackgroundInert(inert) {
    if (!controller.dialog) return;
    [controller.dialog.querySelector('.myx-room-preview__topbar'), controller.stage].forEach(function (element) {
      if (!element) return;
      if (inert) {
        element.setAttribute('inert', '');
        element.setAttribute('aria-hidden', 'true');
      } else {
        element.removeAttribute('inert');
        element.removeAttribute('aria-hidden');
      }
    });
  }

  async function applyComparedSize() {
    if (controller.sizeCommitLock || !controller.sizeCandidate) return;
    var adapter = signatureSizeAdapter();
    if (!adapter) {
      setSizeStatus('Size comparison is still loading. Try again in a moment.', 'error');
      return;
    }
    var choice = controller.sizeCandidate;
    var fromDimensions = copyDimensions(controller.sizeCommittedDimensions);
    var token = ++controller.sizeCommitToken;
    controller.sizeCommitLock = true;
    controller.sizeApplyButton.disabled = true;
    controller.sizeApplyButton.textContent = 'Applying…';
    controller.sizeSheet.classList.add('is-applying');
    setSizeStatus('Applying ' + controller.dimensions.label + ' and updating your price…');
    try {
      var selected = await adapter.commit(choice, fromDimensions.shape);
      if (token !== controller.sizeCommitToken || !controller.dialog || controller.dialog.hidden) return;
      var appliedDimensions = dimensionsFromChoice(selected || choice, fromDimensions.shape);
      if (!sameDimensions(appliedDimensions, dimensionsFromChoice(choice, fromDimensions.shape))) {
        throw new Error('The selected size did not finish applying.');
      }
      controller.sizeCommittedDimensions = copyDimensions(appliedDimensions);
      controller.dimensions = copyDimensions(appliedDimensions);
      updateSizeBadge(controller.dimensions, false);
      var roomPower = controller.mirrorPowered;
      try {
        var artwork = await captureRoomArtworkStates();
        if (token === controller.sizeCommitToken && controller.dialog && !controller.dialog.hidden) {
          controller.artworkSets = { angled: artwork.angled, front: artwork.front };
          applyArtworkForRoom(controller.activeRoom);
          setMirrorPower(roomPower, false);
        }
      } catch (captureError) {
        console.warn('[Maytrix room preview] Size applied, but the room artwork refresh used the previous snapshot.', captureError);
      }
      if (token !== controller.sizeCommitToken || !controller.dialog || controller.dialog.hidden) return;
      updateMirrorLayout();
      controller.sizeCommitLock = false;
      controller.sizeSheet.classList.remove('is-applying');
      setSizeStatus('Applied ' + controller.dimensions.label + '.', 'success');
      track('size_applied', {
        room: controller.activeRoom.id,
        shape: controller.dimensions.shape,
        from_size: fromDimensions.label,
        to_size: controller.dimensions.label
      });
      closeSizeSheet(false, true);
    } catch (error) {
      if (token !== controller.sizeCommitToken) return;
      controller.sizeCommitLock = false;
      controller.sizeSheet.classList.remove('is-applying');
      if (error && error.maytrixRollbackSucceeded === true) {
        controller.sizeCommittedDimensions = copyDimensions(fromDimensions);
        controller.dimensions = copyDimensions(fromDimensions);
        updateSizeBadge(controller.dimensions, false);
        updateMirrorLayout();
      } else {
        syncCommittedSizeFromCustomizer(null);
      }
      controller.sizeCandidate = null;
      controller.sizeApplyButton.disabled = true;
      controller.sizeApplyButton.textContent = 'Use This Size';
      renderSizeChoices();
      setSizeStatus(error && error.maytrixRollbackSucceeded === false
        ? 'The size may have changed. Return to the builder and verify your selection before continuing.'
        : (error && error.message ? error.message + ' Please try again.' : 'The size could not be applied. Please try again.'), 'error');
      track('size_apply_failed', {
        room: controller.activeRoom.id,
        shape: fromDimensions.shape,
        from_size: fromDimensions.label,
        to_size: choice.label || '',
        message: String(error && error.message || error)
      });
    }
  }

  function editCustomSizeInBuilder() {
    if (controller.sizeCommitLock) return;
    closeSizeSheet(true, false);
    closeDialog('edit_custom_size');
    window.setTimeout(function () {
      var category = document.querySelector('[data-category-id="' + SIZE_MODE_CATEGORY_ID + '"]');
      var custom = category && category.querySelector('[data-option-id="' + CUSTOM_SIZE_OPTION_ID + '"]');
      if (custom) custom.click();
      if (category && category.scrollIntoView) category.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 80);
  }

  function showSizeHintOnce() {
    if (!controller.sizeHint) return;
    var seen = false;
    try { seen = window.sessionStorage.getItem(SIZE_HINT_KEY) === '1'; } catch (error) { /* storage is optional */ }
    if (seen) return;
    try { window.sessionStorage.setItem(SIZE_HINT_KEY, '1'); } catch (error) { /* storage is optional */ }
    window.clearTimeout(controller.sizeHintTimer);
    controller.sizeHintTimer = window.setTimeout(function () {
      if (!controller.dialog || controller.dialog.hidden || !controller.sizeSheet.hidden) return;
      controller.sizeHint.hidden = false;
      controller.sizeHintTimer = window.setTimeout(function () {
        if (controller.sizeHint) controller.sizeHint.hidden = true;
      }, 4200);
    }, 700);
  }

  function bindPhotoInput(input, source) {
    input.addEventListener('change', function () {
      var file = input.files && input.files[0];
      input.value = '';
      if (!file) return;
      prepareCustomRoomPhoto(file, source).catch(function (error) {
        console.error('[Maytrix room preview] Unable to prepare the local room photo.', error);
        setCustomPhotoStatus(error && error.message ? error.message : 'We couldn’t read that photo. Try a JPG, PNG, or WebP under 20 MB.', true);
        track('room_preview_custom_photo_error', { source: source });
      });
    });
  }

  function setCustomPhotoStatus(message, isError) {
    if (!controller.customPhotoStatus) return;
    window.clearTimeout(controller.photoStatusTimer);
    controller.customPhotoStatus.textContent = message || '';
    controller.customPhotoStatus.classList.toggle('is-error', !!isError);
    controller.customPhotoStatus.hidden = !message;
    if (message) {
      controller.photoStatusTimer = window.setTimeout(function () {
        if (controller.customPhotoStatus) controller.customPhotoStatus.hidden = true;
      }, isError ? 6000 : 3000);
    }
  }

  function canvasToBlob(canvas, type, quality) {
    return new Promise(function (resolve) {
      canvas.toBlob(function (blob) { resolve(blob || null); }, type, quality);
    });
  }

  async function decodeLocalPhoto(file) {
    if (typeof window.createImageBitmap === 'function') {
      try {
        var orientedBitmap = await window.createImageBitmap(file, { imageOrientation: 'from-image' });
        return {
          image: orientedBitmap,
          width: orientedBitmap.width,
          height: orientedBitmap.height,
          release: function () { if (orientedBitmap.close) orientedBitmap.close(); }
        };
      } catch (error) { /* fall through to the image-element decoder */ }
    }
    var sourceUrl = URL.createObjectURL(file);
    try {
      var image = await loadImage(sourceUrl);
      return {
        image: image,
        width: image.naturalWidth || image.width,
        height: image.naturalHeight || image.height,
        release: function () { URL.revokeObjectURL(sourceUrl); }
      };
    } catch (error) {
      URL.revokeObjectURL(sourceUrl);
      throw error;
    }
  }

  async function optimizeLocalPhoto(file) {
    var type = String(file && file.type || '').toLowerCase();
    var name = String(file && file.name || '').toLowerCase();
    if (!file || !file.size || file.size > MAX_CUSTOM_PHOTO_BYTES || /\.svg(?:z)?$/.test(name) || (type && !/^image\/(?:jpeg|png|webp|heic|heif)$/.test(type))) {
      throw new Error('We couldn’t read that photo. Try a JPG, PNG, or WebP under 20 MB.');
    }

    var decoded;
    try {
      decoded = await decodeLocalPhoto(file);
      if (!decoded.width || !decoded.height) throw new Error('The selected photo has no usable dimensions.');
      var scale = Math.min(1, MAX_CUSTOM_PHOTO_EDGE / Math.max(decoded.width, decoded.height));
      var width = Math.max(1, Math.round(decoded.width * scale));
      var height = Math.max(1, Math.round(decoded.height * scale));
      var canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      var context = canvas.getContext('2d', { alpha: false });
      if (!context) throw new Error('The photo could not be resized on this device.');
      context.imageSmoothingEnabled = true;
      context.imageSmoothingQuality = 'high';
      context.drawImage(decoded.image, 0, 0, width, height);
      var blob = await canvasToBlob(canvas, 'image/webp', 0.84);
      if (!blob) blob = await canvasToBlob(canvas, 'image/jpeg', 0.88);
      canvas.width = 1;
      canvas.height = 1;
      if (!blob) throw new Error('The photo could not be optimized on this device.');
      return { blob: blob, width: width, height: height };
    } catch (error) {
      if (/under 20 MB|could not be resized|could not be optimized/.test(String(error && error.message || ''))) throw error;
      throw new Error('We couldn’t read that photo. Try a JPG, PNG, or WebP under 20 MB.');
    } finally {
      if (decoded && decoded.release) decoded.release();
    }
  }

  async function prepareCustomRoomPhoto(file, source) {
    setCustomPhotoStatus('Preparing your room photo…', false);
    var optimized = await optimizeLocalPhoto(file);
    var nextUrl = URL.createObjectURL(optimized.blob);
    var previousUrl = controller.customPhotoUrl;
    controller.customPhotoUrl = nextUrl;
    customRoom.image = nextUrl;
    customRoom.thumb = nextUrl;
    customRoom.width = optimized.width;
    customRoom.height = optimized.height;
    controller.positions[customRoom.id] = { x: 0.5, y: 0.5 };
    setCustomScale(100, false);
    updateCustomPhotoButton();
    selectRoom(customRoom.id, true);
    if (previousUrl) URL.revokeObjectURL(previousUrl);
    setCustomPhotoStatus('Your room photo is ready.', false);
    track('room_preview_custom_photo_ready', { source: source });
  }

  function updateCustomPhotoButton() {
    if (!controller.customPhotoButton) return;
    if (!controller.customPhotoUrl) {
      var mobilePhotoChoice = isMobilePhotoChoice();
      var uploadLabel = mobilePhotoChoice ? 'Add Your Room' : 'Upload';
      var uploadAccessibleLabel = mobilePhotoChoice ? 'Add your own room photo' : 'Upload your own room photo from this computer';
      controller.customPhotoButton.classList.remove('has-photo');
      controller.customPhotoButton.setAttribute('aria-label', uploadAccessibleLabel);
      controller.customPhotoButton.title = mobilePhotoChoice ? 'Add your room' : 'Upload your own room photo';
      controller.customPhotoButton.innerHTML = '<span class="myx-room-preview__upload-icon">' + svgUploadIcon() + '</span><span class="myx-room-preview__upload-label">' + uploadLabel + '</span>';
      return;
    }
    controller.customPhotoButton.classList.add('has-photo');
    controller.customPhotoButton.setAttribute('aria-label', 'Preview in your uploaded room');
    controller.customPhotoButton.title = 'Your Room';
    controller.customPhotoButton.innerHTML = '<img alt="" src="' + controller.customPhotoUrl + '"><span>Your Room</span>';
  }

  function setCustomScale(value, fromUser) {
    value = clamp(Number(value) || 100, CUSTOM_SCALE_MIN, CUSTOM_SCALE_MAX);
    if (fromUser) value = Math.round(value / CUSTOM_SCALE_STEP) * CUSTOM_SCALE_STEP;
    controller.customScale = value;
    if (controller.customScaleInput) controller.customScaleInput.value = String(Math.round(value));
    if (controller.customScaleOutput) controller.customScaleOutput.textContent = Math.round(value) + '%';
    if (controller.activeRoom && controller.activeRoom.isCustom) updateMirrorLayout();
    if (fromUser) track('room_preview_custom_scale_changed', { scale: value });
  }

  function resetCustomRoomPlacement() {
    controller.positions[customRoom.id] = { x: 0.5, y: 0.5 };
    setCustomScale(100, false);
    updateMirrorLayout();
    track('room_preview_custom_photo_reset');
  }

  function removeCustomRoomPhoto() {
    var previousUrl = controller.customPhotoUrl;
    if (controller.activeRoom && controller.activeRoom.isCustom) selectRoom(defaultRoom().id, true);
    controller.customPhotoUrl = '';
    customRoom.image = '';
    customRoom.thumb = '';
    customRoom.width = 0;
    customRoom.height = 0;
    delete controller.positions[customRoom.id];
    setCustomScale(100, false);
    updateCustomPhotoButton();
    if (previousUrl) URL.revokeObjectURL(previousUrl);
    setCustomPhotoStatus('Your room photo was removed.', false);
    track('room_preview_custom_photo_removed');
  }

  function releaseCustomRoomPhoto() {
    var wasActive = !!(controller.activeRoom && controller.activeRoom.isCustom);
    if (controller.customPhotoUrl) URL.revokeObjectURL(controller.customPhotoUrl);
    controller.customPhotoUrl = '';
    customRoom.image = '';
    customRoom.thumb = '';
    customRoom.width = 0;
    customRoom.height = 0;
    delete controller.positions[customRoom.id];
    if (wasActive) controller.activeRoom = defaultRoom();
    updateCustomPhotoButton();
    if (wasActive && controller.dialog && !controller.dialog.hidden) selectRoom(defaultRoom().id, false);
  }

  function canonicalShape(value) {
    var token = String(value == null ? '' : value)
      .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
    if (/^(?:arch|tombstone|arch tombstone)$/.test(token)) return 'arch';
    if (/^(?:octagon|octagonal)$/.test(token)) return 'octagon';
    if (/^(?:landscape|landscape rectangle|horizontal rectangle|rectangle|rect)$/.test(token)) return 'rectangle';
    if (/^(?:portrait|portrait rectangle|vertical rectangle|vrect)$/.test(token)) return 'vrect';
    if (/^(?:oval horizontal|horizontal oval|capsule horizontal|horizontal capsule|hoval)$/.test(token)) return 'hoval';
    if (/^(?:oval vertical|vertical oval|capsule vertical|vertical capsule|voval)$/.test(token)) return 'voval';
    if (token === 'round') return 'circle';
    if (token === 'circle' || token === 'square') return token;
    return 'square';
  }

  function positiveNumber(value) {
    if (value == null || value === '') return 0;
    var match = String(value).replace(/,/g, '').match(/\d+(?:\.\d+)?/);
    var parsed = match ? parseFloat(match[0]) : 0;
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
  }

  function currentViewerState() {
    var viewer = window.__MAYTRIX_VIEWER__;
    if (!viewer || typeof viewer.getState !== 'function') return {};
    try { return viewer.getState() || {}; } catch (error) { return {}; }
  }

  function currentDimensions(stateOverride) {
    var state = stateOverride && typeof stateOverride === 'object' ? stateOverride : currentViewerState();
    var shape = canonicalShape(state.shape);
    var custom = /custom|manual/i.test(String(state.sizeMode || ''));
    var unit = custom && String(state.sizeUnit || '').toLowerCase() === 'cm' ? 'cm' : 'in';
    var width;
    var height;

    if (custom) {
      width = positiveNumber(state.sizeCustomWidth);
      height = positiveNumber(state.sizeCustomLength);
    } else {
      var longSide = positiveNumber(state.size) || 24;
      var elongatedPreset = /^(?:rectangle|vrect|hoval|voval|arch)$/.test(shape);
      var shortSide = positiveNumber(state.sizePresetShort);
      if (!shortSide || (elongatedPreset && shortSide >= longSide)) {
        shortSide = elongatedPreset ? longSide / 2 : longSide;
      }
      width = longSide;
      height = shortSide;
      if (/^(?:square|circle|octagon)$/.test(shape)) {
        width = height = Math.max(width, height);
      } else if (/^(?:vrect|voval|arch)$/.test(shape) && width > height) {
        var portraitWidth = height;
        height = width;
        width = portraitWidth;
      } else if (/^(?:rectangle|hoval)$/.test(shape) && width < height) {
        var landscapeWidth = height;
        height = width;
        width = landscapeWidth;
      }
    }

    width = width || 24;
    height = height || 24;
    var widthInches = unit === 'cm' ? width / 2.54 : width;
    var heightInches = unit === 'cm' ? height / 2.54 : height;
    var compact = function (number) { return String(parseFloat(Number(number).toFixed(1))); };

    return {
      shape: shape,
      width: width,
      height: height,
      unit: unit,
      widthInches: widthInches,
      heightInches: heightInches,
      label: compact(width) + ' × ' + compact(height) + ' ' + unit
    };
  }

  function nextFrame() {
    return new Promise(function (resolve) { window.requestAnimationFrame(resolve); });
  }

  function timeout(ms, value) {
    return new Promise(function (resolve) { window.setTimeout(function () { resolve(value); }, ms); });
  }

  async function waitForRoomRendererSettle() {
    var previousSignature = '';
    var stableFrames = 0;
    for (var frame = 0; frame < 24 && stableFrames < 4; frame += 1) {
      await nextFrame();
      var dimensions = currentDimensions();
      var signature = [
        dimensions.shape,
        Number(dimensions.widthInches || 0).toFixed(3),
        Number(dimensions.heightInches || 0).toFixed(3)
      ].join('|');
      stableFrames = signature === previousSignature ? stableFrames + 1 : 1;
      previousSignature = signature;
    }
    await timeout(110);
    await nextFrame();
    await nextFrame();
  }

  async function preserveArtworkBounds(snapshot) {
    var normalized = await normalizeSnapshotSource(snapshot);
    if (typeof normalized === 'string' && /^data:image\/png(?:;|,)/i.test(normalized)) return normalized;
    var image = await loadImage(normalized);
    var width = image.width || image.naturalWidth;
    var height = image.height || image.naturalHeight;
    if (!width || !height) throw new Error('The design snapshot has no dimensions.');
    var canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    var context = canvas.getContext('2d');
    if (!context) throw new Error('The room preview could not preserve the design snapshot.');
    context.drawImage(image, 0, 0, width, height);
    return canvas.toDataURL('image/png');
  }

  async function captureTransparentRoomArtwork(options) {
    options = options || {};
    await nextFrame();
    await nextFrame();

    var renderer = window.__MAYTRIX_ROOM_RENDERER__;
    if (renderer && typeof renderer.capture === 'function') {
      try {
        var transparent = renderer.capture({
          maxEdge: MAX_CAPTURE_EDGE,
          mode: options.mode || 'room-on',
          view: options.view || 'front',
          aspect: controller.dimensions && controller.dimensions.heightInches
            ? controller.dimensions.widthInches / controller.dimensions.heightInches
            : 1
        });
        if (transparent) return preserveArtworkBounds(transparent);
      } catch (error) {
        console.warn('[Maytrix room preview] Transparent capture failed; using the safe snapshot fallback.', error);
      }
    }

    var front = window.cpbImageStorage && window.cpbImageStorage.views && window.cpbImageStorage.views.front;
    if (!front || typeof front.getSnapshot !== 'function') throw new Error('Front snapshot provider is unavailable.');
    var snapshot = await Promise.race([
      Promise.resolve(front.getSnapshot([1])),
      timeout(3500, null)
    ]);
    if (!snapshot) throw new Error('Front snapshot timed out.');
    return prepareArtwork(snapshot, true);
  }

  function builderPowerButton() {
    return document.querySelector('#product-builder #viewer-3d-root .preview-power');
  }

  function builderPowerIsOn(button) {
    return !!(button && button.classList.contains('is-on'));
  }

  async function setBuilderPower(button, powered) {
    if (!button || !button.isConnected || builderPowerIsOn(button) === powered) return;
    button.click();
    for (var frame = 0; frame < 12; frame += 1) {
      await nextFrame();
      if (!button.isConnected || builderPowerIsOn(button) === powered) return;
    }
    throw new Error('The infinity mirror power state did not settle.');
  }

  async function captureRoomArtworkStates() {
    await waitForRoomRendererSettle();
    var powerButton = builderPowerButton();
    if (!powerButton) {
      var fallback = await captureTransparentRoomArtwork({ mode: 'room-on', view: 'front' });
      return {
        angled: { on: fallback, off: '' },
        front: { on: fallback, off: '' },
        initialOn: true
      };
    }

    var initialOn = builderPowerIsOn(powerButton);
    var captured = {
      angled: { on: '', off: '' },
      front: { on: '', off: '' },
      initialOn: initialOn
    };
    var captureError = null;
    try {
      await setBuilderPower(powerButton, true);
      captured.angled.on = await captureTransparentRoomArtwork({ mode: 'room-on', view: 'low' });
      captured.front.on = await captureTransparentRoomArtwork({ mode: 'room-on', view: 'front' });
      await setBuilderPower(powerButton, false);
      captured.angled.off = await captureTransparentRoomArtwork({ mode: 'room-off', view: 'low' });
      captured.front.off = await captureTransparentRoomArtwork({ mode: 'room-off', view: 'front' });
    } catch (error) {
      captureError = error;
    } finally {
      try { await setBuilderPower(powerButton, initialOn); } catch (restoreError) {
        console.warn('[Maytrix room preview] The builder power state could not be restored automatically.', restoreError);
      }
    }
    if (!captured.angled.on && !captured.angled.off && !captured.front.on && !captured.front.off) {
      throw captureError || new Error('The room artwork could not be captured.');
    }
    if (!captured.angled.on) captured.angled.on = captured.angled.off || captured.front.on || captured.front.off;
    if (!captured.front.on) captured.front.on = captured.front.off || captured.angled.on;
    if (!captured.angled.off) captured.angled.off = captured.front.off;
    if (!captured.front.off) captured.front.off = captured.angled.off;
    captured.front = await cropRoomArtworkPair(captured.front);
    return captured;
  }

  async function cropRoomArtworkPair(pair) {
    // Use one crop for both light states, so switching the lights never moves
    // or resizes the frame. Only transparent capture padding is removed.
    var states = ['on', 'off'];
    var canvases = [];
    var width = 0, height = 0, minX = Infinity, minY = Infinity, maxX = -1, maxY = -1;
    for (var stateIndex = 0; stateIndex < states.length; stateIndex += 1) {
      if (!pair[states[stateIndex]]) { canvases.push(null); continue; }
      var image = await loadImage(pair[states[stateIndex]]);
      var canvas = document.createElement('canvas');
      canvas.width = image.naturalWidth || image.width;
      canvas.height = image.naturalHeight || image.height;
      if (width && (width !== canvas.width || height !== canvas.height)) return pair;
      width = canvas.width; height = canvas.height;
      var context = canvas.getContext('2d', { willReadFrequently: true });
      if (!context) return pair;
      context.drawImage(image, 0, 0);
      var data = context.getImageData(0, 0, width, height).data;
      for (var pixel = 3, index = 0; pixel < data.length; pixel += 4, index += 1) {
        if (data[pixel] > 48) {
          var x = index % width, y = Math.floor(index / width);
          minX = Math.min(minX, x); maxX = Math.max(maxX, x);
          minY = Math.min(minY, y); maxY = Math.max(maxY, y);
        }
      }
      canvases.push(canvas);
    }
    if (maxX < minX || maxY < minY) return pair;
    var aspect = width / height;
    var cropWidth = Math.min(width, (maxX - minX + 1) * 1.03);
    var cropHeight = Math.min(height, (maxY - minY + 1) * 1.03);
    if (cropWidth / cropHeight < aspect) cropWidth = Math.min(width, cropHeight * aspect);
    else cropHeight = Math.min(height, cropWidth / aspect);
    var left = clamp((minX + maxX + 1 - cropWidth) / 2, 0, width - cropWidth);
    var top = clamp((minY + maxY + 1 - cropHeight) / 2, 0, height - cropHeight);
    var result = { on: '', off: '' };
    canvases.forEach(function (canvas, index) {
      if (!canvas) return;
      var cropped = document.createElement('canvas');
      cropped.width = Math.round(cropWidth); cropped.height = Math.round(cropHeight);
      var context = cropped.getContext('2d');
      if (!context) { result[states[index]] = pair[states[index]]; return; }
      context.drawImage(canvas, left, top, cropWidth, cropHeight, 0, 0, cropped.width, cropped.height);
      result[states[index]] = cropped.toDataURL('image/png');
    });
    return result;
  }

  function applyArtworkForRoom(room) {
    if (!controller.mirrorArt || !controller.mirrorArtOff) return;
    var sets = controller.artworkSets || {};
    var selected = sets.front;
    selected = selected || sets.angled || sets.front || { on: '', off: '' };
    controller.artworkUrl = selected.on || selected.off || '';
    controller.artworkOffUrl = selected.off || '';
    if (controller.artworkUrl) controller.mirrorArt.src = controller.artworkUrl;
    if (controller.artworkUrl || controller.artworkOffUrl) {
      controller.mirrorArtOff.src = controller.artworkOffUrl || controller.artworkUrl;
    }
    if (controller.lightButton) controller.lightButton.hidden = !controller.artworkOffUrl;
    if (!controller.artworkOffUrl) controller.mirrorPowered = true;
  }

  function setMirrorPower(powered, fromUser) {
    if (!controller.artworkOffUrl) powered = true;
    controller.mirrorPowered = !!powered;
    if (controller.mirror) controller.mirror.classList.toggle('is-off', !controller.mirrorPowered);
    if (controller.lightButton) {
      controller.lightButton.classList.toggle('is-on', controller.mirrorPowered);
      controller.lightButton.classList.toggle('is-off', !controller.mirrorPowered);
      controller.lightButton.setAttribute('aria-pressed', controller.mirrorPowered ? 'true' : 'false');
      controller.lightButton.setAttribute('aria-label', controller.mirrorPowered ? 'Turn infinity mirror off' : 'Turn infinity mirror on');
    }
    if (fromUser) track('room_preview_power_toggled', {
      room: controller.activeRoom.id,
      powered: controller.mirrorPowered ? 'on' : 'off'
    });
  }

  function blobToDataUrl(blob) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onload = function () { resolve(String(reader.result || '')); };
      reader.onerror = function () { reject(new Error('Unable to read the design snapshot.')); };
      reader.readAsDataURL(blob);
    });
  }

  async function normalizeSnapshotSource(source) {
    var candidate = Array.isArray(source) ? source[0] : source;
    var isBitmap = typeof ImageBitmap !== 'undefined' && candidate instanceof ImageBitmap;
    if (candidate instanceof HTMLCanvasElement || candidate instanceof HTMLImageElement || isBitmap) return candidate;
    if (candidate instanceof Blob) return blobToDataUrl(candidate);
    if (candidate && typeof candidate === 'object') {
      candidate = candidate.canvas || candidate.dataUrl || candidate.dataURL || candidate.url || candidate.src || candidate.image || candidate.blob || '';
      isBitmap = typeof ImageBitmap !== 'undefined' && candidate instanceof ImageBitmap;
      if (candidate instanceof HTMLCanvasElement || candidate instanceof HTMLImageElement || isBitmap) return candidate;
      if (candidate instanceof Blob) return blobToDataUrl(candidate);
    }
    if (typeof candidate !== 'string' || !candidate) throw new Error('The design snapshot was empty.');
    if (/^data:/i.test(candidate) || /^blob:/i.test(candidate)) return candidate;
    var response = await fetch(candidate, { credentials: 'same-origin' });
    if (!response.ok) throw new Error('The design snapshot could not be loaded.');
    return blobToDataUrl(await response.blob());
  }

  function loadImage(source) {
    var isBitmap = typeof ImageBitmap !== 'undefined' && source instanceof ImageBitmap;
    if (source instanceof HTMLCanvasElement || source instanceof HTMLImageElement || isBitmap) {
      return Promise.resolve(source);
    }
    return new Promise(function (resolve, reject) {
      var image = new Image();
      image.decoding = 'async';
      image.onload = function () { resolve(image); };
      image.onerror = function () { reject(new Error('The design snapshot image could not be decoded.')); };
      image.src = source;
    });
  }

  async function prepareArtwork(snapshot, allowDarkKey) {
    var normalized = await normalizeSnapshotSource(snapshot);
    var image = await loadImage(normalized);
    var sourceWidth = image.width || image.naturalWidth;
    var sourceHeight = image.height || image.naturalHeight;
    if (!sourceWidth || !sourceHeight) throw new Error('The design snapshot has no dimensions.');

    var canvas = document.createElement('canvas');
    canvas.width = sourceWidth;
    canvas.height = sourceHeight;
    var context = canvas.getContext('2d', { willReadFrequently: true });
    if (!context) throw new Error('The room preview could not create an image canvas.');
    context.drawImage(image, 0, 0, sourceWidth, sourceHeight);

    var pixels = context.getImageData(0, 0, sourceWidth, sourceHeight);
    var data = pixels.data;
    var transparentCount = 0;
    for (var index = 3; index < data.length; index += 4) {
      if (data[index] < 8) transparentCount += 1;
    }
    var hasRealTransparency = transparentCount > (sourceWidth * sourceHeight * 0.02);

    if (!hasRealTransparency && allowDarkKey) {
      for (var pixel = 0; pixel < data.length; pixel += 4) {
        var brightest = Math.max(data[pixel], data[pixel + 1], data[pixel + 2]);
        if (brightest <= 22) data[pixel + 3] = 0;
        else if (brightest < 50) data[pixel + 3] = Math.round(data[pixel + 3] * ((brightest - 22) / 28));
      }
      context.putImageData(pixels, 0, 0);
      hasRealTransparency = true;
    }

    var minX = sourceWidth;
    var minY = sourceHeight;
    var maxX = -1;
    var maxY = -1;
    for (var y = 0; y < sourceHeight; y += 1) {
      for (var x = 0; x < sourceWidth; x += 1) {
        var alpha = data[(y * sourceWidth + x) * 4 + 3];
        if (alpha > 12) {
          if (x < minX) minX = x;
          if (x > maxX) maxX = x;
          if (y < minY) minY = y;
          if (y > maxY) maxY = y;
        }
      }
    }

    if (maxX < minX || maxY < minY) throw new Error('The design snapshot contained no visible pixels.');
    var pad = Math.max(2, Math.round(Math.max(maxX - minX, maxY - minY) * 0.015));
    minX = Math.max(0, minX - pad);
    minY = Math.max(0, minY - pad);
    maxX = Math.min(sourceWidth - 1, maxX + pad);
    maxY = Math.min(sourceHeight - 1, maxY + pad);

    var cropWidth = maxX - minX + 1;
    var cropHeight = maxY - minY + 1;
    var cropped = document.createElement('canvas');
    cropped.width = cropWidth;
    cropped.height = cropHeight;
    var croppedContext = cropped.getContext('2d');
    if (!croppedContext) throw new Error('The room preview could not crop the design snapshot.');
    croppedContext.drawImage(canvas, minX, minY, cropWidth, cropHeight, 0, 0, cropWidth, cropHeight);
    return cropped.toDataURL('image/png');
  }

  function useMobileRoomImage(room) {
    return !!(room && !room.isCustom && room.mobileImage && window.matchMedia && window.matchMedia('(max-width: 640px)').matches);
  }

  function roomPixelsPerInch(room) {
    return useMobileRoomImage(room) ? room.mobilePixelsPerInch : room.pixelsPerInch;
  }

  function defaultRoomPosition(room) {
    return useMobileRoomImage(room)
      ? { x: room.mobileX == null ? room.x : room.mobileX, y: room.mobileY == null ? room.y : room.mobileY }
      : { x: room.x, y: room.y };
  }

  function roomPositionKey(room) {
    return room.isCustom ? room.id : room.id + (useMobileRoomImage(room) ? ':mobile' : ':desktop');
  }

  function roomImageSource(room) {
    if (!room) return '';
    return useMobileRoomImage(room) ? room.mobileImage : (room.image || '');
  }

  function roomImageSize(room) {
    if (room && room.isCustom) return { width: room.width, height: room.height };
    if (useMobileRoomImage(room)) return { width: room.mobileWidth, height: room.mobileHeight };
    return { width: room.width, height: room.height };
  }

  function selectRoom(roomId, fromUser) {
    if ((controller.dragging || controller.pinching) && fromUser) return;
    var room = roomId === customRoom.id && controller.customPhotoUrl ? customRoom : rooms.find(function (item) { return item.id === roomId; }) || defaultRoom();
    var loadToken = ++controller.roomLoadToken;
    controller.activeRoom = room;
    applyArtworkForRoom(room);
    controller.roomButtons.forEach(function (button) {
      button.setAttribute('aria-pressed', button.getAttribute('data-room-id') === room.id ? 'true' : 'false');
    });
    if (!controller.positions[roomPositionKey(room)]) controller.positions[roomPositionKey(room)] = defaultRoomPosition(room);
    controller.sceneImage.alt = room.isCustom ? 'Your room photo' : room.label + ' room visualization';
    controller.sceneImage.classList.toggle('is-custom-photo', !!room.isCustom);
    controller.stage.classList.toggle('is-custom-photo', !!room.isCustom);
    if (controller.customControls) controller.customControls.hidden = !room.isCustom;
    if (controller.tip) controller.tip.querySelector('span').textContent = room.isCustom ? 'Drag to position • Pinch or use Mockup size to resize' : 'Drag to reposition';

    var roomImage = roomImageSource(room);
    var resolvedRoomImage = roomImage ? new URL(roomImage, window.location.href).href : '';
    if (controller.sceneImage.src === resolvedRoomImage && controller.sceneImage.complete) {
      updateMirrorLayout();
    } else {
      controller.sceneImage.classList.add('is-switching');
      controller.mirror.classList.add('is-room-switching');
      controller.sceneImage.onload = function () {
        if (loadToken !== controller.roomLoadToken) return;
        updateMirrorLayout();
        window.requestAnimationFrame(function () {
          if (loadToken !== controller.roomLoadToken) return;
          controller.sceneImage.classList.remove('is-switching');
          controller.mirror.classList.remove('is-room-switching');
        });
      };
      controller.sceneImage.onerror = function () {
        if (loadToken !== controller.roomLoadToken) return;
        controller.sceneImage.classList.remove('is-switching');
        controller.mirror.classList.remove('is-room-switching');
      };
      controller.sceneImage.src = roomImage;
    }
    if (fromUser) track('room_preview_room_selected', { room: room.id, size: controller.dimensions && controller.dimensions.label });
  }

  function stageMetrics() {
    if (!controller.stage || !controller.activeRoom) return null;
    var width = controller.stage.clientWidth;
    var height = controller.stage.clientHeight;
    if (!width || !height) return null;
    var room = controller.activeRoom;
    var imageSize = roomImageSize(room);
    if (!imageSize.width || !imageSize.height) return null;
    var scale = room.isCustom ? Math.min(width / imageSize.width, height / imageSize.height) : Math.max(width / imageSize.width, height / imageSize.height);
    var zoom = 1;
    if (!room.isCustom && controller.dimensions) {
      var ppi = roomPixelsPerInch(room);
      // Move the camera, not just the product: the entire room and mirror use
      // the same zoom, preserving their relative proportions. Pull back for 6ft squares.
      var preferredZoom = useMobileRoomImage(room) ? 1.20 : 1;
      var widthLimit = width * .82 / (controller.dimensions.widthInches * ppi * scale);
      var heightLimit = height * .66 / (controller.dimensions.heightInches * ppi * scale);
      zoom = Math.max(1, Math.min(preferredZoom, widthLimit, heightLimit));
      scale *= zoom;
    }
    var renderedWidth = imageSize.width * scale;
    var renderedHeight = imageSize.height * scale;
    var focal = defaultRoomPosition(room);
    if (!room.isCustom && controller.dimensions) {
      var wall = useMobileRoomImage(room) ? room.mobileWall : room.wall;
      var halfX = controller.dimensions.widthInches * roomPixelsPerInch(room) / imageSize.width / 2;
      var halfY = controller.dimensions.heightInches * roomPixelsPerInch(room) / imageSize.height / 2;
      focal.x = clamp(focal.x, wall.xMin + halfX, wall.xMax - halfX);
      focal.y = clamp(focal.y, wall.yMin + halfY, wall.yMax - halfY);
    }
    var offsetX = room.isCustom ? (width - renderedWidth) / 2 : clamp(width / 2 - focal.x * renderedWidth, width - renderedWidth, 0);
    var offsetY = room.isCustom ? (height - renderedHeight) / 2 : clamp(height * .40 - focal.y * renderedHeight, height - renderedHeight, 0);
    return {
      width: width, height: height, scale: scale, zoom: zoom,
      renderedWidth: renderedWidth, renderedHeight: renderedHeight,
      offsetX: offsetX, offsetY: offsetY
    };
  }

  function clamp(value, minimum, maximum) {
    if (maximum < minimum) return (minimum + maximum) / 2;
    return Math.min(maximum, Math.max(minimum, value));
  }

  function positionBounds(room, metrics, mirrorWidth, mirrorHeight) {
    var halfX = mirrorWidth / metrics.renderedWidth / 2;
    var halfY = mirrorHeight / metrics.renderedHeight / 2;
    var visibleMinX = (-metrics.offsetX) / metrics.renderedWidth;
    var visibleMaxX = (metrics.width - metrics.offsetX) / metrics.renderedWidth;
    var visibleMinY = (-metrics.offsetY) / metrics.renderedHeight;
    var visibleMaxY = (metrics.height - metrics.offsetY) / metrics.renderedHeight;
    var wall = useMobileRoomImage(room) ? room.mobileWall : room.wall;
    var minX = Math.max(wall ? wall.xMin + halfX : room.xMin, visibleMinX + halfX);
    var maxX = Math.min(wall ? wall.xMax - halfX : room.xMax, visibleMaxX - halfX);
    var minY = Math.max(wall ? wall.yMin + halfY : room.yMin, visibleMinY + halfY);
    var maxY = Math.min(wall ? wall.yMax - halfY : room.yMax, visibleMaxY - halfY);
    return { minX: minX, maxX: maxX, minY: minY, maxY: maxY };
  }

  function normalizedPosition(room, metrics, mirrorWidth, mirrorHeight) {
    var position = controller.positions[roomPositionKey(room)] || defaultRoomPosition(room);
    var bounds = positionBounds(room, metrics, mirrorWidth, mirrorHeight);
    position.x = clamp(position.x, bounds.minX, bounds.maxX);
    position.y = clamp(position.y, bounds.minY, bounds.maxY);
    controller.positions[roomPositionKey(room)] = position;
    return position;
  }

  function applyMirrorTransform(metrics, position, mirrorWidth, mirrorHeight) {
    var left = metrics.offsetX + position.x * metrics.renderedWidth - mirrorWidth / 2;
    var top = metrics.offsetY + position.y * metrics.renderedHeight - mirrorHeight / 2;
    controller.mirror.style.transform = 'translate3d(' + left.toFixed(2) + 'px,' + top.toFixed(2) + 'px,0)';
  }

  function updateMirrorLayout() {
    if (!controller.dialog || controller.dialog.hidden || !controller.dimensions || !controller.mirror || controller.dragging) return;
    var metrics = stageMetrics();
    if (!metrics) return;
    var room = controller.activeRoom;
    // Position the photo with exactly the same geometry used for the overlay.
    controller.sceneImage.style.width = metrics.renderedWidth + 'px';
    controller.sceneImage.style.height = metrics.renderedHeight + 'px';
    controller.sceneImage.style.transform = 'translate3d(' + metrics.offsetX + 'px,' + metrics.offsetY + 'px,0)';
    var rawWidth;
    var rawHeight;
    if (room.isCustom) {
      var nominalPixelsPerInch = Math.min(metrics.renderedWidth / 120, metrics.renderedHeight / 96);
      var manualScale = controller.customScale / 100;
      rawWidth = controller.dimensions.widthInches * nominalPixelsPerInch * manualScale;
      rawHeight = controller.dimensions.heightInches * nominalPixelsPerInch * manualScale;
    } else {
      rawWidth = controller.dimensions.widthInches * roomPixelsPerInch(room) * metrics.scale;
      rawHeight = controller.dimensions.heightInches * roomPixelsPerInch(room) * metrics.scale;
    }
    var maxWidth = Math.min(metrics.renderedWidth * 0.78, metrics.width * 0.84);
    var maxHeight = Math.min(metrics.renderedHeight * 0.72, metrics.height * 0.78);
    var activeWall = useMobileRoomImage(room) ? room.mobileWall : room.wall;
    if (!room.isCustom && activeWall) {
      maxWidth = Math.min(maxWidth, (activeWall.xMax - activeWall.xMin) * metrics.renderedWidth * 0.96);
      maxHeight = Math.min(maxHeight, (activeWall.yMax - activeWall.yMin) * metrics.renderedHeight * 0.96);
    }
    var maxFit = Math.min(maxWidth / rawWidth, maxHeight / rawHeight);
    var fit = Math.min(1, maxFit);
    var minimumFit = 28 / Math.min(rawWidth, rawHeight);
    if (minimumFit <= maxFit) fit = Math.max(fit, minimumFit);
    var mirrorWidth = rawWidth * fit;
    var mirrorHeight = rawHeight * fit;
    var position = normalizedPosition(room, metrics, mirrorWidth, mirrorHeight);
    controller.mirror.style.width = mirrorWidth + 'px';
    controller.mirror.style.height = mirrorHeight + 'px';
    applyMirrorTransform(metrics, position, mirrorWidth, mirrorHeight);
  }

  function beginDrag(event) {
    if (event.button != null && event.button !== 0) return;
    var metrics = stageMetrics();
    if (!metrics) return;
    var room = controller.activeRoom;
    if (room.isCustom) {
      controller.customPointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
      try { controller.mirror.setPointerCapture(event.pointerId); } catch (error) { /* optional */ }
      if (controller.customPointers.size >= 2) {
        if (controller.dragging && controller.dragging.frame) window.cancelAnimationFrame(controller.dragging.frame);
        controller.dragging = null;
        controller.mirror.classList.remove('is-dragging');
        var pinchPoints = Array.from(controller.customPointers.values()).slice(0, 2);
        controller.pinching = {
          startDistance: Math.max(1, Math.hypot(pinchPoints[1].x - pinchPoints[0].x, pinchPoints[1].y - pinchPoints[0].y)),
          startScale: controller.customScale
        };
        controller.mirror.classList.add('is-pinching');
        event.preventDefault();
        return;
      }
    }
    var mirrorWidth = controller.mirror.offsetWidth;
    var mirrorHeight = controller.mirror.offsetHeight;
    var position = normalizedPosition(room, metrics, mirrorWidth, mirrorHeight);
    var rect = controller.stage.getBoundingClientRect();
    var pointerX = event.clientX - rect.left;
    var pointerY = event.clientY - rect.top;
    var centerX = metrics.offsetX + position.x * metrics.renderedWidth;
    var centerY = metrics.offsetY + position.y * metrics.renderedHeight;
    controller.dragging = {
      pointerId: event.pointerId,
      room: room,
      metrics: metrics,
      rect: rect,
      mirrorWidth: mirrorWidth,
      mirrorHeight: mirrorHeight,
      bounds: positionBounds(room, metrics, mirrorWidth, mirrorHeight),
      offsetX: centerX - pointerX,
      offsetY: centerY - pointerY,
      nextX: position.x,
      nextY: position.y,
      frame: 0
    };
    controller.mirror.classList.add('is-dragging');
    try { controller.mirror.setPointerCapture(event.pointerId); } catch (error) { /* optional */ }
    event.preventDefault();
  }

  function paintDragFrame(dragging) {
    if (!controller.dragging || controller.dragging !== dragging) return;
    dragging.frame = 0;
    var position = { x: dragging.nextX, y: dragging.nextY };
    controller.positions[roomPositionKey(dragging.room)] = position;
    applyMirrorTransform(dragging.metrics, position, dragging.mirrorWidth, dragging.mirrorHeight);
  }

  function moveDrag(event) {
    if (controller.activeRoom && controller.activeRoom.isCustom && controller.customPointers.has(event.pointerId)) {
      controller.customPointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
      if (controller.pinching && controller.customPointers.size >= 2) {
        var pinchPoints = Array.from(controller.customPointers.values()).slice(0, 2);
        var distance = Math.max(1, Math.hypot(pinchPoints[1].x - pinchPoints[0].x, pinchPoints[1].y - pinchPoints[0].y));
        setCustomScale(controller.pinching.startScale * distance / controller.pinching.startDistance, false);
        event.preventDefault();
        return;
      }
    }
    if (!controller.dragging || controller.dragging.pointerId !== event.pointerId) return;
    var dragging = controller.dragging;
    var centerX = event.clientX - dragging.rect.left + dragging.offsetX;
    var centerY = event.clientY - dragging.rect.top + dragging.offsetY;
    dragging.nextX = clamp(
      (centerX - dragging.metrics.offsetX) / dragging.metrics.renderedWidth,
      dragging.bounds.minX,
      dragging.bounds.maxX
    );
    dragging.nextY = clamp(
      (centerY - dragging.metrics.offsetY) / dragging.metrics.renderedHeight,
      dragging.bounds.minY,
      dragging.bounds.maxY
    );
    if (!dragging.frame) {
      dragging.frame = window.requestAnimationFrame(function () { paintDragFrame(dragging); });
    }
    event.preventDefault();
  }

  function endDrag(event) {
    if (controller.customPointers.has(event.pointerId)) {
      controller.customPointers.delete(event.pointerId);
      if (controller.pinching) {
        try { controller.mirror.releasePointerCapture(event.pointerId); } catch (error) { /* optional */ }
        if (controller.customPointers.size < 2) {
          controller.pinching = null;
          controller.mirror.classList.remove('is-pinching');
          track('room_preview_custom_scale_changed', { scale: controller.customScale, source: 'pinch' });
        }
        event.preventDefault();
        return;
      }
    }
    if (!controller.dragging || controller.dragging.pointerId !== event.pointerId) return;
    var dragging = controller.dragging;
    if (dragging.frame) {
      window.cancelAnimationFrame(dragging.frame);
      dragging.frame = 0;
    }
    paintDragFrame(dragging);
    try { controller.mirror.releasePointerCapture(event.pointerId); } catch (error) { /* optional */ }
    controller.dragging = null;
    controller.mirror.classList.remove('is-dragging');
    if (!controller.placedThisOpen) {
      controller.placedThisOpen = true;
      track('room_preview_placed', { room: controller.activeRoom.id, size: controller.dimensions && controller.dimensions.label });
    }
  }

  function focusableElements() {
    if (!controller.dialog) return [];
    var scope = controller.sizeSheet && !controller.sizeSheet.hidden
      ? controller.sizeSheet
      : (controller.customPhotoSheet && !controller.customPhotoSheet.hidden ? controller.customPhotoSheet : controller.dialog);
    return Array.prototype.slice.call(scope.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]):not([type="hidden"]),[tabindex]:not([tabindex="-1"])'))
      .filter(function (element) { return !element.hidden && element.offsetParent !== null; });
  }

  function handleDialogKey(event) {
    if (!controller.dialog || controller.dialog.hidden) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      if (controller.sizeSheet && !controller.sizeSheet.hidden) {
        closeSizeSheet(true, true);
        return;
      }
      if (controller.customPhotoSheet && !controller.customPhotoSheet.hidden) {
        closeCustomPhotoSheet();
        return;
      }
      closeDialog('escape');
      return;
    }
    if (controller.embedded) return;
    if (event.key !== 'Tab') return;
    var focusables = focusableElements();
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function scheduleEmbeddedBuilderSync() {
    if (!controller.embedded || !controller.dialog || controller.dialog.hidden) return;
    controller.builderSyncToken += 1;
    window.clearTimeout(controller.builderUpdateTimer);
    controller.builderUpdateTimer = window.setTimeout(refreshEmbeddedFromBuilder, 260);
  }

  async function refreshEmbeddedFromBuilder() {
    controller.builderUpdateTimer = 0;
    if (!controller.embedded || !controller.dialog || controller.dialog.hidden) return;
    if (controller.sizeCommitLock) {
      scheduleEmbeddedBuilderSync();
      return;
    }
    var token = ++controller.builderSyncToken;
    var powered = controller.mirrorPowered;
    try {
      await waitForRoomRendererSettle();
      if (token !== controller.builderSyncToken || !controller.embedded || controller.dialog.hidden) return;
      var dimensions = currentDimensions();
      controller.dimensions = copyDimensions(dimensions);
      controller.sizeCommittedDimensions = copyDimensions(dimensions);
      controller.sizeCandidate = null;
      updateSizeBadge(controller.dimensions, false);
      controller.mirror.className = 'myx-room-preview__mirror myx-room-preview__mirror--' + controller.dimensions.shape;
      updateMirrorLayout();
      var artwork = await captureRoomArtworkStates();
      if (token !== controller.builderSyncToken || !controller.embedded || controller.dialog.hidden) return;
      controller.artworkSets = { angled: artwork.angled, front: artwork.front };
      applyArtworkForRoom(controller.activeRoom);
      setMirrorPower(powered, false);
      controller.mirror.hidden = false;
      controller.loading.hidden = true;
      controller.error.hidden = true;
      updateMirrorLayout();
      track('room_preview_builder_synced', {
        room: controller.activeRoom.id,
        size: controller.dimensions.label,
        shape: controller.dimensions.shape
      });
    } catch (error) {
      if (token !== controller.builderSyncToken || !controller.embedded || controller.dialog.hidden) return;
      console.warn('[Maytrix room preview] The live builder update could not be reflected in the room preview yet.', error);
    }
  }

  async function openDialog() {
    if (!isBuilderMode()) return;
    var dialog = buildDialog();
    var token = ++controller.openToken;
    controller.lastFocused = document.activeElement;
    controller.previousBodyOverflow = document.body.style.overflow;
    controller.dimensions = currentDimensions();
    controller.sizeCommittedDimensions = copyDimensions(controller.dimensions);
    controller.sizeCandidate = null;
    controller.sizeCommitLock = false;
    controller.positions = {};
    controller.placedThisOpen = false;
    updateSizeBadge(controller.dimensions, false);
    controller.mirror.className = 'myx-room-preview__mirror myx-room-preview__mirror--' + controller.dimensions.shape;
    controller.mirror.hidden = true;
    controller.lightButton.hidden = true;
    controller.loading.hidden = false;
    controller.error.hidden = true;
    dialog.hidden = false;
    document.body.classList.add('myx-room-open');
    setPreviewLayoutMode(usesDesktopEmbeddedPreview());
    selectRoom(controller.activeRoom.id, false);
    controller.keyHandler = handleDialogKey;
    document.addEventListener('keydown', controller.keyHandler, true);
    controller.resizeHandler = function () {
      var shouldEmbed = usesDesktopEmbeddedPreview();
      if (shouldEmbed !== controller.embedded) setPreviewLayoutMode(shouldEmbed);
      if (controller.embedded) scheduleEmbeddedBoundsSync();
      var expectedSource = roomImageSource(controller.activeRoom);
      var resolvedSource = expectedSource ? new URL(expectedSource, window.location.href).href : '';
      if (resolvedSource && controller.sceneImage.src !== resolvedSource) selectRoom(controller.activeRoom.id, false);
      else updateMirrorLayout();
    };
    window.addEventListener('resize', controller.resizeHandler);
    dialog.querySelector('.myx-room-preview__close').focus({ preventScroll: true });
    track('room_preview_opened', { room: controller.activeRoom.id, size: controller.dimensions.label, shape: controller.dimensions.shape });

    try {
      var artwork = await captureRoomArtworkStates();
      if (token !== controller.openToken || dialog.hidden) return;
      controller.artworkSets = {
        angled: artwork.angled,
        front: artwork.front
      };
      applyArtworkForRoom(controller.activeRoom);
      setMirrorPower(artwork.initialOn, false);
      controller.mirror.hidden = false;
      controller.loading.hidden = true;
      updateMirrorLayout();
      showSizeHintOnce();
      track('room_preview_ready', { room: controller.activeRoom.id, size: controller.dimensions.label, capture: window.__MAYTRIX_ROOM_RENDERER__ ? 'transparent' : 'snapshot_fallback' });
    } catch (error) {
      if (token !== controller.openToken || dialog.hidden) return;
      console.error('[Maytrix room preview] Unable to prepare the room preview.', error);
      controller.loading.hidden = true;
      controller.error.hidden = false;
      track('room_preview_error', { message: String(error && error.message || error) });
    }
  }

  function closeDialog(reason) {
    if (!controller.dialog || controller.dialog.hidden) return;
    if (controller.sizeCommitLock) {
      setSizeStatus('Please wait while your size finishes applying.');
      return;
    }
    controller.openToken += 1;
    controller.sizeCommitToken += 1;
    controller.builderSyncToken += 1;
    window.clearTimeout(controller.builderUpdateTimer);
    controller.builderUpdateTimer = 0;
    controller.sizeCommitLock = false;
    window.clearTimeout(controller.sizeHintTimer);
    if (controller.sizeHint) controller.sizeHint.hidden = true;
    if (controller.sizeSheet && !controller.sizeSheet.hidden) {
      controller.sizeSheet.classList.remove('is-applying');
      controller.sizeSheet.hidden = true;
      controller.sizeBadge.setAttribute('aria-expanded', 'false');
      controller.dialog.classList.remove('is-size-sheet-open');
      setRoomBackgroundInert(false);
      controller.sizeCandidate = null;
      controller.sizeSheetOpener = null;
    }
    teardownEmbeddedTracking();
    controller.embedded = false;
    controller.dialog.hidden = true;
    document.body.classList.remove('myx-room-open');
    document.body.classList.remove('myx-room-open--embedded');
    document.body.style.overflow = controller.previousBodyOverflow || '';
    if (controller.keyHandler) document.removeEventListener('keydown', controller.keyHandler, true);
    if (controller.resizeHandler) window.removeEventListener('resize', controller.resizeHandler);
    controller.keyHandler = null;
    controller.resizeHandler = null;
    if (controller.dragging && controller.dragging.frame) window.cancelAnimationFrame(controller.dragging.frame);
    controller.dragging = null;
    controller.pinching = null;
    controller.customPointers.clear();
    if (controller.mirror) controller.mirror.classList.remove('is-dragging', 'is-pinching');
    closeCustomPhotoSheet(false);
    track('room_preview_closed', { reason: reason || 'close', room: controller.activeRoom.id, placed: controller.placedThisOpen });
    if (controller.lastFocused && controller.lastFocused.focus && controller.lastFocused.isConnected) {
      try { controller.lastFocused.focus({ preventScroll: true }); } catch (error) { controller.lastFocused.focus(); }
    }
  }

  function watchBuilder() {
    mountCta();
    window.addEventListener('click', handleDelegatedCtaClick, true);
    controller.observer = new MutationObserver(function () {
      if (!isBuilderMode()) {
        closeDialog('review');
        if (controller.ctaWrapper) controller.ctaWrapper.classList.remove('myx-room-cta-ready');
        return;
      }
      mountCta();
    });
    controller.observer.observe(document.body, { childList: true, subtree: true });
    controller.modeObserver = new MutationObserver(function () {
      if (!isBuilderMode()) {
        closeDialog('review');
        if (controller.ctaWrapper) controller.ctaWrapper.classList.remove('myx-room-cta-ready');
        return;
      }
      mountCta();
    });
    controller.modeObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', function () {
      mountCta();
      scheduleEmbeddedBuilderSync();
    });
    document.body.addEventListener('CPB_ON_OPTIONS_UPDATE', function () {
      syncBuilderSizePresentation();
      scheduleEmbeddedBuilderSync();
    });
    document.addEventListener('maytrix:customizer-option-state', scheduleEmbeddedBuilderSync);
    window.addEventListener('maytrix:builder-reveal-visible', markBuilderReady);
    document.addEventListener('maytrix:builder-reveal-visible', markBuilderReady);
    controller.readinessTimer = window.setInterval(function () {
      var ready = window.MyxUx && typeof window.MyxUx.builderSurfaceReady === 'function' && window.MyxUx.builderSurfaceReady();
      if (ready) markBuilderReady();
    }, 250);
    window.setTimeout(function () {
      if (!controller.builderReady && document.querySelector('#viewer-3d-root canvas') && !document.querySelector('#product-builder .cpb-loader:not([style*="display: none"])')) {
        markBuilderReady();
      }
    }, 12000);
    window.addEventListener('pageshow', mountCta);
    window.addEventListener('pagehide', releaseCustomRoomPhoto);
    window.addEventListener('popstate', function () {
      if (!isBuilderMode()) closeDialog('navigation');
      mountCta();
    });
  }

  window.__MAYTRIX_ROOM_PREVIEW__ = Object.freeze({
    version: VERSION,
    open: openDialog,
    close: closeDialog,
    getState: function () {
      return {
        open: !!(controller.dialog && !controller.dialog.hidden),
        room: controller.activeRoom.id,
        dimensions: controller.dimensions,
        powered: controller.mirrorPowered,
        captureAvailable: !!(window.__MAYTRIX_ROOM_RENDERER__ && window.__MAYTRIX_ROOM_RENDERER__.capture)
      };
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchBuilder, { once: true });
  else watchBuilder();
})();
